const optionalSubjectDetails = {
  Anthropology: {
    papers: [
      {
        title: "PAPER - I",
        topics: [
          {
            section: "1.1 Meaning, scope and development of Anthropology.",
            points: []
          },
          {
            section: "1.2 Relationships with other disciplines:",
            points: [
              "Social Sciences, Behavioural Sciences, Life Sciences, Medical Sciences, Earth Sciences and Humanities."
            ]
          },
          {
            section: "1.3 Main branches of Anthropology, their scope and relevance:",
            points: [
              "a) Social- cultural Anthropology.",
              "b) Biological Anthropology.",
              "c) Archaeological Anthropology.",
              "d) Linguistic Anthropology."
            ]
          },
          {
            section: "1.4 Human Evolution and emergence of Man:",
            points: [
              "a) Biological and Cultural factors in human evolution.",
              "b) Theories of Organic Evolution (PreDarwinian, Darwinian and Post-Darwinian).",
              "c) Synthetic theory of evolution; Brief outline of terms and concepts of evolutionary biology (Doll’s rule, Cope’s rule, Gause’s rule, parallelism, convergence, adaptive radiation, and mosaic evolution)."
            ]
          },
          {
            section: "1.5 Characteristics of Primates;",
            points: [
              "Evolutionary Trend and Primate Taxonomy; Primate Adaptations; (Arboreal and Terrestrial) Primate Taxonomy; Primate Behaviour; Tertiary and Quaternary fossil primates; Living Major Primates; Comparative Anatomy of Man and Apes; Skeletal changes due to erect posture and its implications."
            ]
          },
          {
            section: "1.6 Phylogenetic status, characteristics and geographical distribution of the following:",
            points: [
              "a) Plio-pleistocene hominids in South and East Africa - Australopithecines.",
              "b) Homo erectus: Africa (Paranthropus), Europe (Homo erectus heidelbergensis), Asia (Homo erectus (a) javanicus, Homo erectus pekinensis).",
              "c) Neanderthal Man- La-Chapelle-auxsaints (Classical type), Mt. Carmel (Progressive type).",
              "d) Rhodesian man.",
              "e) Homo sapiens — Cromagnon, Grimaldi and Chancelede."
            ]
          },
          {
            section: "1.7 The biological basis of life:",
            points: [
              "The Cell, DNA structure and replication, Protein Synthesis, Gene, Mutation, Chromosomes, and Cell Division."
            ]
          },
          {
            section: "1.8 Principles of Prehistoric Archaeology. Chronology:",
            points: [
              "Relative and Absolute Dating methods.",
              "Cultural Evolution- Broad Outlines of Prehistoric cultures:",
              "a)Paleolithic",
              "b) Mesolithic",
              "c) Neolithic",
              "d) Chalcolithic",
              "e) Copper-Bronze Age",
              "f) Iron Age"
            ]
          },
          {
            section: "2.1 The Nature of Culture:",
            points: [
              "The concept and characteristics of culture and civilization; Ethnocentrism vis-à-vis cultural Relativism."
            ]
          },
          {
            section: "2.2 The Nature of Society:",
            points: [
              "Concept of Society; Society and Culture; Social Institutions; Social groups; and Social stratification."
            ]
          },
          {
            section: "2.3 Marriage:",
            points: [
              "Definition and universality; Laws of marriage (endogamy, exogamy, hypergamy, hypogamy, incest taboo); Types of marriage (monogamy, polygamy, polyandry, group marriage). Functions of marriage; Marriage regulations (preferential, prescriptive and proscriptive); Marriage payments (bride wealth and dowry)."
            ]
          },
          {
            section: "2.4 Family:",
            points: [
              "Definition and universality; Family, household and domestic groups; functions of family; Types of family (from the perspectives of structure, blood relation, marriage, residence and succession); Impact of urbanization, industrialization and feminist movements on family."
            ]
          },
          {
            section: "2.5 Kinship:",
            points: [
              "Consanguinity and Affinity; Principles and types of descent (Unilineal, Double, Bilateral, Ambilineal); Forms of descent groups (lineage, clan, phratry, moiety and kindred); Kinship terminology (descriptive and classificatory); Descent, Filiation and Complimentary Filiation; Descent and Alliance."
            ]
          },
          {
            section: "3. Economic organization:",
            points: [
              "Meaning, scope and relevance of economic anthropology; Formalist and Substantivist debate; Principles governing production, distribution and exchange (reciprocity, redistribution and market), in communities, subsisting on hunting and gathering, fishing, swiddening, pastoralism, horticulture, and agriculture; globalization and indigenous economic systems."
            ]
          },
          {
            section: "4. Political organization and Social Control:",
            points: [
              "Band, tribe, chiefdom, kingdom and state; concepts of power, authority and legitimacy; social control, law and justice in simple societies."
            ]
          },
          {
            section: "5. Religion:",
            points: [
              "Anthropological approaches to the study of religion (evolutionary, psychological and functional); monotheism and polytheism; sacred and profane; myths and rituals; forms of religion in tribal and peasant societies (animism, animatism, fetishism, naturism and totemism); religion, magic and science distinguished; magicoreligious functionaries (priest, shaman, medicine man, sorcerer and witch)."
            ]
          },
          {
            section: "6. Anthropological theories:",
            points: [
              "a) Classical evolutionism (Tylor, Morgan and Frazer)",
              "b) Historical particularism (Boas); Diffusionism (British, German and American)",
              "c) Functionalism (Malinowski); Structural-functionlism (Radcliffe-Brown)",
              "d) Structuralism (L’evi - Strauss and E.Leach)",
              "e) Culture and personality (Benedict, Mead, Linton, Kardiner and Cora – du Bois).",
              "f) Neo - evolutionism (Childe, White, Steward, Sahlins and Service)",
              "g) Cultural materialism (Harris)",
              "h) Symbolic and interpretive theories (Turner, Schneider and Geertz)",
              "i) Cognitive theories (Tyler, Conklin)",
              "j) Post- modernism in anthropology"
            ]
          },
          {
            section: "7. Culture, language and communication:",
            points: [
              "Nature, origin and characteristics of language; verbal and non-verbal communication; social context of language use."
            ]
          },
          {
            section: "8. Research methods in anthropology:",
            points: [
              "a) Fieldwork tradition in anthropology",
              "b) Distinction between technique, method and methodology",
              "c) Tools of data collection: observation, interview, schedules, questionnaire, Case study, genealogy, life history, oral history, secondary sources of information, participatory methods.",
              "d) Analysis, interpretation and presentation of data."
            ]
          },
          {
            section: "9.1 Human Genetics: Methods and Application:",
            points: [
              "Methods for study of genetic principles in man-family study (pedigree analysis, twin study, foster child, co-twin method, cytogenetic method, chromosomal and karyo-type analysis), biochemical methods, immunological methods, D.N.A. technology and recombinant technologies."
            ]
          },
          {
            section: "9.2 Mendelian genetics in man-family study,",
            points: [
              "single factor, multifactor, lethal, sublethal and polygenic inheritance in man."
            ]
          },
          {
            section: "9.3 Concept of genetic polymorphism and selection,",
            points: [
              "Mendelian population, HardyWeinberg law; causes and changes which bring down frequency – mutation, isolation, migration, selection, inbreeding and genetic drift. Consanguineous and non-consanguineous mating, genetic load, genetic effect of consanguineous and cousin marriages."
            ]
          },
          {
            section: "9.4 Chromosomes and chromosomal aberrations in man, methodology.",
            points: [
              "a) Numerical and structural aberrations (disorders).",
              "b) Sex chromosomal aberrations – Klinefelter (XXY), Turner (XO), Super female (XXX), intersex and other syndromic disorders.",
              "c) Autosomal aberrations – Down syndrome, Patau, Edward and Cri-du-chat syndromes.",
              "d) Genetic imprints in human disease, genetic screening, genetic counseling, human DNA profiling, gene mapping and genome study."
            ]
          },
          {
            section: "9.5 Race and racism,",
            points: [
              "biological basis of morphological variation of non-metric and metric characters. Racial criteria, racial traits in relation to heredity and environment; biological basis of racial classification, racial differentiation and race crossing in man."
            ]
          },
          {
            section: "9.6 Age, sex and population variation as genetic marker-",
            points: [
              "ABO, Rh blood groups, HLA Hp, transferring, Gm, blood enzymes. Physiological characteristics-Hb level, body fat, pulse rate, respiratory functions and sensory perceptions in different cultural and socio-economic groups."
            ]
          },
          {
            section: "9.7 Concepts and methods of Ecological Anthropology.",
            points: [
              "Bio-cultural Adaptations – Genetic and Non-genetic factors. Man’s physiological responses to environmental stresses: hot desert, cold, high altitude climate."
            ]
          },
          {
            section: "9.8 Epidemiological Anthropology:",
            points: [
              "Health and disease. Infectious and non-infectious diseases. Nutritional deficiency related diseases."
            ]
          },
          {
            section: "10. Concept of human growth and development:",
            points: [
              "stages of growth - pre-natal, natal, infant, childhood, adolescence, maturity, senescence.",
              "Factors affecting growth and development genetic, environmental, biochemical, nutritional, cultural and socio-economic.",
              "Ageing and senescence. Theories and observations - biological and chronological longevity. Human physique and somatotypes. Methodologies for growth studies."
            ]
          },
          {
            section: "11.1 Relevance of menarche, menopause and other bioevents to fertility.",
            points: [
              "Fertility patterns and differentials."
            ]
          },
          {
            section: "11.2 Demographic theories-",
            points: [
              "biological, social and cultural."
            ]
          },
          {
            section: "11.3 Biological and socio-ecological factors influencing fecundity, fertility, natality and mortality.",
            points: []
          },
          {
            section: "12. Applications of Anthropology:",
            points: [
              "Anthropology of sports, Nutritional anthropology, Anthropology in designing of defence and other equipments, Forensic Anthropology, Methods and principles of personal identification and reconstruction, Applied human genetics – Paternity diagnosis, genetic counseling and eugenics, DNA technology in diseases and medicine, serogenetics and cytogenetics in reproductive biology."
            ]
          }
        ]
      },
      {
        title: "PAPER – II",
        topics: [
          {
            section: "1.1Evolution of the Indian Culture and Civilization:",
            points: [
              "Prehistoric (Palaeolithic, Mesolithic, Neolithic and Neolithic Chalcolithic). Protohistoric (Indus Civilization): Pre- Harappan, Harappan and Post Harappan cultures. Contributions of tribal cultures to Indian civilization."
            ]
          },
          {
            section: "1.2 Palaeo:",
            points: [
              "Anthropological evidences from India with special reference to Siwaliks and Narmada basin (Ramapithecus, Sivapithecus and Narmada Man)."
            ]
          },
          {
            section: "1.3 Ethno-archaeology in India:",
            points: [
              "The concept of ethno-archaeology; Survivals and Parallels among the hunting, foraging, fishing, pastoral and peasant communities including arts and crafts producing communities."
            ]
          },
          {
            section: "2. Demographic profile of India:",
            points: [
              "Ethnic and linguistic elements in the Indian population and their distribution. Indian population – factors influencing its structure and growth."
            ]
          },
          {
            section: "3.1The structure and nature of traditional Indian social system:",
            points: [
              "Varnashram, Purushartha, Karma, Rina and Rebirth."
            ]
          },
          {
            section: "3.2 Caste system in India:",
            points: [
              "Structure and characteristics, Varna and caste, Theories of origin of caste system, Dominant caste, Caste mobility, Future of caste system, Jajmani system, Tribe- caste continuum."
            ]
          },
          {
            section: "3.3 Sacred Complex and Nature- Man-Spirit Complex.",
            points: []
          },
          {
            section: "3.4 Impact of Buddhism, Jainism, Islam and Christianity on Indian society.",
            points: []
          },
          {
            section: "4. Emergence and growth of anthropology in India:",
            points: [
              "Contributions of the 18th, 19th and early 20th Century scholar-administrators. Contributions of Indian anthropologists to tribal and caste studies."
            ]
          },
          {
            section: "5.1 Indian Village:",
            points: [
              "Significance of village study in India; Indian village as a social system; Traditional and changing patterns of settlement and inter-caste relations; Agrarian relations in Indian villages; Impact of globalization on Indian villages."
            ]
          },
          {
            section: "5.2 Linguistic and religious minorities and their social, political and economic status.",
            points: []
          },
          {
            section: "5.3 Indigenous and exogenous processes of socio-cultural change in Indian society:",
            points: [
              "Sanskritization, Westernization, Modernization; Inter-play of little and great traditions; Panchayati raj and social change; Media and social change."
            ]
          },
          {
            section: "6.1 Tribal situation in India:",
            points: [
              "Bio-genetic variability, linguistic and socio-economic characteristics of tribal populations and their distribution."
            ]
          },
          {
            section: "6.2 Problems of the tribal Communities:",
            points: [
              "land alienation, poverty, indebtedness, low literacy, poor educational facilities, unemployment, underemployment, health and nutrition."
            ]
          },
          {
            section: "6.3 Developmental projects and their impact on tribal displacement and problems of rehabilitation.",
            points: [
              "Development of forest policy and tribals. Impact of urbanization and industrialization on tribal populations."
            ]
          },
          {
            section: "7.1 Problems of exploitation and deprivation of Scheduled Castes, Scheduled Tribes and Other Backward Classes.",
            points: [
              "Constitutional safeguards for Scheduled Tribes and Scheduled Castes."
            ]
          },
          {
            section: "7.2 Social change and contemporary tribal societies:",
            points: [
              "Impact of modern democratic institutions, development programmes and welfare measures on tribals and weaker sections."
            ]
          },
          {
            section: "7.3 The concept of ethnicity;",
            points: [
              "Ethnic conflicts and political developments; Unrest among tribal communities; Regionalism and demand for autonomy; Pseudo-tribalism; Social change among the tribes during colonial and post-Independent India."
            ]
          },
          {
            section: "8.1 Impact of Hinduism, Buddhism, Christianity, Islam and other religions on tribal societies.",
            points: []
          },
          {
            section: "8.2 Tribe and nation state:",
            points: [
              "A comparative study of tribal communities in India and other countries."
            ]
          },
          {
            section: "9.1 History of administration of tribal areas,",
            points: [
              "tribal policies, plans, programmes of tribal development and their implementation. The concept of PTGs (Primitive Tribal Groups), their distribution, special programmes for their development. Role of N.G.O.s in tribal development."
            ]
          },
          {
            section: "9.2 Role of anthropology in tribal and rural development.",
            points: []
          },
          {
            section: "Contributions of anthropology to the understanding of regionalism, communalism, and ethnic and political movements.",
            points: []
          }
        ]
      }
    ]
  },
  Geography: {
    papers: [
      {
        title: "PAPER - I: PRINCIPLES OF GEOGRAPHY",
        topics: [
          {
            section: "Physical Geography:",
            points: [
              {
                title: "1. Geomorphology:",
                subpoints: [
                  "Factors controlling landform development; endogenetic and exogenetic forces; Origin and evolution of the earth’s crust; Fundamentals of geomagnetism; Physical conditions of the earth’s interior; Geosynclines; Continental drift; Isostasy; Plate tectonics; Recent views on mountain building; Vulcanicity; Earthquakes and Tsunamis; Concepts of geomorphic cycles and Landscape development ; Denudation chronology; Channel morphology; Erosion surfaces; Slope development; Applied Geomorphology : Geohydrology, economic geology and environment."
                ]
              },
              {
                title: "2. Climatology:",
                subpoints: [
                  "Temperature and pressure belts of the world; Heat budget of the earth; Atmospheric circulation; atmospheric stability and instability. Planetary and local winds; Monsoons and jet streams; Air masses and fronto genesis, Temperate and tropical cyclones; Types and distribution of precipitation; Weather and Climate; Koppen’s, Thornthwaite’s and Trewartha’s classification of world climates; Hydrological cycle; Global climatic change and role and response of man in climatic changes, Applied climatology and Urban climate."
                ]
              },
              {
                title: "3. Oceanography:",
                subpoints: [
                  "Bottom topography of the Atlantic, Indian and Pacific Oceans; Temperature and salinity of the oceans; Heat and salt budgets, Ocean deposits; Waves, currents and tides; Marine resources: biotic, mineral and energy resources; Coral reefs, coral bleaching; sealevel changes; law of the sea and marine pollution."
                ]
              },
              {
                title: "4. Biogeography:",
                subpoints: [
                  "Genesis of soils; Classification and distribution of soils; Soil profile; Soil erosion, Degradation and conservation; Factors influencing world distribution of plants and animals; Problems of deforestation and conservation measures; Social forestry; agro-forestry; Wild life; Major gene pool centres."
                ]
              },
              {
                title: "5. Environmental Geography:",
                subpoints: [
                  "Principle of ecology; Human ecological adaptations; Influence of man on ecology and environment; Global and regional ecological changes and imbalances; Ecosystem their management and conservation; Environmental degradation, management and conservation; Biodiversity and sustainable development; Environmental policy; Environmental hazards and remedial measures; Environmental education and legislation."
                ]
              }
            ]
          },
          {
            section: "Human Geography:",
            points: [
              {
                title: "1. Perspectives in Human Geography:",
                subpoints: [
                  "Areal differentiation; regional synthesis; Dichotomy and dualism; Environmentalism; Quantitative revolution and locational analysis; radical, behavioural, human and welfare approaches; Languages, religions and secularisation; Cultural regions of the world; Human development index."
                ]
              },
              {
                title: "2. Economic Geography:",
                subpoints: [
                  "World economic development: measurement and problems; World resources and their distribution; Energy crisis; the limits to growth; World agriculture: typology of agricultural regions; agricultural inputs and productivity; Food and nutrition problems; Food security; famine: causes, effects and remedies; World industries: locational patterns and problems; patterns of world trade."
                ]
              },
              {
                title: "3. Population and Settlement Geography:",
                subpoints: [
                  "Growth and distribution of world population; demographic attributes; Causes and consequences of migration; concepts of over-under-and optimum population; Population theories, world population problems and policies, Social well-being and quality of life; Population as social capital.",
                  "Types and patterns of rural settlements; Environmental issues in rural settlements; Hierarchy of urban settlements; Urban morphology: Concepts of primate city and rank-size rule; Functional classification of towns; Sphere of urban influence; Rural urban fringe; Satellite towns; Problems and remedies of urbanization; Sustainable development of cities."
                ]
              },
              {
                title: "4. Regional Planning:",
                subpoints: [
                  "Concept of a region; Types of regions and methods of regionalisation; Growth centres and growth poles; Regional imbalances; regional development strategies; environmental issues in regional planning; Planning for sustainable development."
                ]
              },
              {
                title: "5. Models, Theories and Laws in Human Geography:",
                subpoints: [
                  "Systems analysis in Human geography; Malthusian, Marxian and demographic transition models; Central Place theories of Christaller and Losch;Perroux and Boudeville; Von Thunen’s model of agricultural location; Weber’s model of industrial location; Ostov’s model of stages of growth. Heartland and Rimland theories; Laws of international boundaries and frontiers."
                ]
              }
            ]
          }
        ]
      },
      {
        title: "PAPER – II: GEOGRAPHY OF INDIA",
        topics: [
          {
            section: "1. Physical Setting:",
            points: [
              "Space relationship of India with neighboring countries; Structure and relief; Drainage system and watersheds; Physiographic regions; Mechanism of Indian monsoons and rainfall patterns, Tropical cyclones and western disturbances; Floods and droughts; Climatic regions; Natural vegetation; Soil types and their distributions."
            ]
          },
          {
            section: "2. Resources:",
            points: [
              "Land, surface and ground water, energy, minerals, biotic and marine resources; Forest and wild life resources and their conservation; Energy crisis."
            ]
          },
          {
            section: "3. Agriculture:",
            points: [
              "Infrastructure: irrigation, seeds, fertilizers, power; Institutional factors: land holdings, land tenure and land reforms; Cropping pattern, agricultural productivity, agricultural intensity, crop combination, land capability; Agro and social-forestry; Green revolution and its socio-economic and ecological implications; Significance of dry farming; Livestock resources and white revolution; aqua - culture; sericulture, apiculture and poultry; agricultural regionalisation; agro-climatic zones; agro- ecological regions."
            ]
          },
          {
            section: "4. Industry:",
            points: [
              "Evolution of industries; Locational factors of cotton, jute, textile, iron and steel, aluminium, fertilizer, paper, chemical and pharmaceutical, automobile, cottage and agro-based industries; Industrial houses and complexes including public sector undertakings; Industrial regionalisation; New industrial policies; Multinationals and liberalization; Special Economic Zones; Tourism including eco-tourism."
            ]
          },
          {
            section: "5. Transport, Communication and Trade:",
            points: [
              "Road, railway, waterway, airway and pipeline networks and their complementary roles in regional development; Growing importance of ports on national and foreign trade; Trade balance; Trade Policy; Export processing zones; Developments in communication and information technology and their impacts on economy and society; Indian space programme."
            ]
          },
          {
            section: "6. Cultural Setting:",
            points: [
              "Historical Perspective of Indian Society; Racial, linguistic and ethnic diversities; religious minorities; major tribes, tribal areas and their problems; cultural regions; Growth, distribution and density of population; Demographic attributes: sex-ratio, age structure, literacy rate, work-force, dependency ratio, longevity; migration (inter-regional, intra- regional and international) and associated problems; Population problems and policies; Health indicators."
            ]
          },
          {
            section: "7. Settlements:",
            points: [
              "Types, patterns and morphology of rural settlements; Urban developments; Morphology of Indian cities; Functional classification of Indian cities; Conurbations and metropolitan regions; urban sprawl; Slums and associated problems; town planning; Problems of urbanization and remedies."
            ]
          },
          {
            section: "8. Regional Development and Planning:",
            points: [
              "Experience of regional planning in India; Five Year Plans; Integrated rural development programmes; Panchayati Raj and decentralised planning; Command area development; Watershed management; Planning for backward area, desert, drought prone, hill, tribal area development; multi-level planning; Regional planning and development of island territories."
            ]
          },
          {
            section: "9. Political Aspects:",
            points: [
              "Geographical basis of Indian federalism; State reorganisation; Emergence of new states; Regional consciousness and inter state issues; international boundary of India and related issues; Cross border terrorism; India’s role in world affairs; Geopolitics of South Asia and Indian Ocean realm."
            ]
          },
          {
            section: "10. Contemporary Issues:",
            points: [
              "Ecological issues: Environmental hazards: landslides, earthquakes, Tsunamis, floods and droughts, epidemics; Issues relating to environmental pollution; Changes in patterns of land use; Principles of environmental impact assessment and environmental management; Population explosion and food security; Environmental degradation; Deforestation, desertification and soil erosion; Problems of agrarian and industrial unrest; Regional disparities in economic development; Concept of sustainable growth and development; Environmental awareness; Linkage of rivers; Globalisation and Indian economy."
            ]
          },
          {
            section: "NOTE:",
            points: [
              "Candidates will be required to answer one compulsory map question pertinent to subjects covered by this paper."
            ]
          }
        ]
      }
    ]
  },
  Economics: {
    papers: [
      {
        title: "Paper – I",
        topics: [
          {
            section: "1. Advanced Micro Economics",
            points: [
              "a) Marshallian and Walrasian Approaches to Price determination",
              "b) Alternative Distribution Theories – Ricardo, Kaldor, Kalecki",
              "c) Market Structures – Monopolistic Competition, Duopoly, Oligopoly",
              "d) Modern Welfare Criteria – Pareto, Hicks, Scitovsky, Arrow, A.K. Sen"
            ]
          },
          {
            section: "2. Advanced Macro Economics",
            points: [
              "a) Approaches to Employment, Income, and Interest Rate determination",
              "b) Theories of Interest Rate determination and Interest Rate Structure"
            ]
          },
          {
            section: "3. Money, Banking and Finance",
            points: [
              {
                title: "Demand for and Supply of Money : Money Multiplier Quantity Theory of Money (Fisher, Pigou and Friedman) and Keynes’ Theory on Demand for Money, Goals and Instruments of Monetary Management in Closed and Open Economies. Relation between the Central Bank and the Treasury. Proposal for ceiling on growth rate of money."
              },
              {
                title: "Public Finance and its Role in market economy : in stabilization of supply, allocation of resources and in distribution and development. Sources of Government revenue, forms of Taxes and Subsidies, their incidence and effects. Limits to taxation, loans, crowding-out effects and limits to borrowings. Public expenditure and its effects."
              }
            ]
          },
          {
            section: "4. International Economics",
            points: [
              {
                title: "Old and New theories of International Trade.",
                subpoints: [
                  "a) Comparative advantage.",
                  "b) Terms of Trade and offer curve.",
                  "c) Product cycle and Strategic trade theories.",
                  "Trade as an engine ozf growth and theories of underdevelopment in an open economy."
                ]
              },
              {
                title: "Forms of protection :",
                subpoints: "Tariff and quota."
              },
              {
                title: "Balance of Payments Adjustments : Alternative Approaches.",
                subpoints: [
                  "Price versus income, income adjustments under fixed exchange rates.",
                  "Theories of Policy mix.",
                  "Exchange rate adjustments under capital mobility.",
                  "Floating Rates and their implications for developing Countries: Currency Boards.",
                  "Trade Policy and Developing Countries.",
                  "BOP, adjustments and Policy Coordination in open economy macro-model.",
                  "Speculative attacks.",
                  "Trade Blocks and Monetary Unions.",
                  "WTO : Trims, TRIPS, Domestic Measures, Different Rounds of WTO talks."
                ]
              }
            ]
          },
          {
            section: "5. Growth and Development",
            points: [
              {
                subpoints: [
                  "a)Theories of growth : Harrod’s model",
                  "b) Lewis model of development with surplus labour.",
                  "c) Balanced Unbalanced Growth.",
                  "d) Human capitals and Economic Growth.",
                  "e) Research and Development and Economic Growth."
                ]
              },
              {
                subpoints: [
                  "Process of Economic Development of less developed countries: Myrdal and Kuznets on economic development and structural change: Role of Agriculture in Economic Development of less developed countries."
                ]
              },
              {
                subpoints: [
                  "Economic Development and International Trade and Investment, Role of Multinationals."
                ]
              },
              {
                subpoints: [
                  "Planning and economic Development: changing role of Markets and Planning, Private-Public Partnership."
                ]
              },
              {
                subpoints: [
                  "Welfare indicators and measures of growth—Human development indices. The basic needs approach."
                ]
              },
              {
                subpoints: [
                  "Development and Environmental Sustainability—Renewable and Non Renewable Resources, Environmental Degradation, Intergenerational equity development"
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Paper – II",
        topics: [
          {
            section: "1. Indian Economy in Pre-Independence Era :",
            points: [
              {
                title: "Land System changes and Commercialization of Agriculture"
              },
              {
                title: "Drain Theory, Laissez-faire Policy, and Industrialization (Jute, Cotton, Railways)"
              }
            ]
          },
          {
            section: "2. Indian Economy after Independence :",
            points: [
              {
                title: "2.1 The Pre-Liberalization Era :",
                subpoints: [
                  "a) Contribution of Vakil, Gadgil and V.K.R.V. Rao.",
                  "b) Agriculture: Land Reforms and land tenure system, Green Revolution and capital formation in agriculture.",
                  "c) Industry Trends in composition and growth, Role of public and private sector, Small scale and cottage industries.",
                  "d) National and Per capita income : patterns, trends, aggregate and Sectoral composition and changes therein.",
                  "e) Broad factors determining National Income and distribution, Measures of poverty, Trends in poverty and inequality."
                ]
              },
              {
                title: "2.2 The Post Liberalization Era :",
                subpoints: [
                  "a) New Economic Reform and Agriculture: Agriculture and WTO, Food processing, subsidies, Agricultural prices and public distribution system, Impact of public expenditure on agricultural growth.",
                  "b) New Economic Policy and Industry: Strategy of industrialization, Privatization, Disinvestments, Role of foreign direct investment and multinationals.",
                  "c) New Economic Policy and Trade: Intellectual property rights : Implications of TRIPS, TRIMS, GATS and new EXIM policy.",
                  "d) New Economic Policy and Public Finance : Fiscal Responsibility Act, Twelfth Finance Commission and Fiscal Federalism and Fiscal Consolidation.",
                  "e) New Economic Policy and Monetary system. Role of RBI under the new regime.",
                  "f) Planning: From central Planning to indicative planning, Relation between planning and markets for growth and decentralized planning: 73rd and 74th Constitutional amendments.",
                  "g) New Economic Policy and Employment: Employment and poverty, Rural wages, Employment Generation, Poverty alleviation schemes, New Rural, Employment Guarantee Scheme."
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  Chemistry: {
    papers: [
      {
        title: "PAPER-I",
        topics: [
          {
            section: "1. Atomic Structure :",
            points: [
              "Heisenberg's uncertainty principle Schrodinger wave equation (time independent); Interpretation of wave function, particle in one- dimensional box, quantum numbers, hydrogen atom wave functions; Shapes of s, p and d orbitals."
            ]
          },
          {
            section: "2. Chemical bonding :",
            points: [
              "Ionic bond, characteristics of ionic compounds, lattice energy, Born-Haber cycle; covalent bond and its general characteristics, polarities of bonds in molecules and their dipole moments; Valence bond theory, concept of resonance and resonance energy; Molecular orbital theory (LCAO method); bonding H2 +, H2 He2 + to Ne2, NO, CO, HF, CN–, Comparison of valence bond and molecular orbital theories, bond order, bond strength and bond length."
            ]
          },
          {
            section: "3. Solid state :",
            points: [
              "Crystal systems; Designation of crystal faces, lattice structures and unit cell; Bragg's law; X-ray diffraction by crystals; Close packing, radius ratio rules, calculation of some limiting radius ratio values; Structures of NaCl, ZnS, CsCl, CaF2; stoichiometric and nonstoichiometric defects, impurity defects, semi-conductors."
            ]
          },
          {
            section: "4. The gaseous state and Transport Phenomenon :",
            points: [
              "Equation of state for real gases, intermolecular interactions, and critical phenomena and liquefaction of gases; Maxwell’s distribution of speeds, intermolecular collisions, collisions on the wall and effusion; Thermal conductivity and viscosity of ideal gases."
            ]
          },
          {
            section: "5. Liquid State :",
            points: [
              "Kelvin equation; Surface tension and surface energy, wetting and contact angle, interfacial tension and capillary action."
            ]
          },
          {
            section: "6. Thermodynamics :",
            points: [
              "Work, heat and internal energy; first law of thermodynamics. Second law of thermodynamics; entropy as a state function, entropy changes in various processes, entropy-reversibility and irreversibility, Free energy functions; Thermodynamic equation of state; Maxwell relations; Temperature, volume and pressure dependence of U, H, A, G, Cp and Cv, □□and□□ ; J-T effect and inversion temperature; criteria for equilibrium, relation between equilibrium constant and thermodynamic quantities; Nernst heat theorem, introductory idea of third law of thermodynamics."
            ]
          },
          {
            section: "7. Phase equilibria and solutions :",
            points: [
              "Clausius-Clapeyron equation; phase diagram for a pure substance; phase equilibria in binary systems, partially miscible liquids—upper and lower critical solution temperatures; partial molar quantities, their significance and determination; excess thermodynamic functions and their determination."
            ]
          },
          {
            section: "8. Electrochemistry :",
            points: [
              "Debye-Huckel theory of strong electrolytes and Debye-Huckel limiting Law for various equilibrium and transport properties.",
              "Galvanic cells, concentration cells; electrochemical series, measurement of e.m.f. of cells and its applications fuel cells and batteries.",
              "Processes at electrodes; double layer at the interface; rate of charge transfer, current density; overpotential; electroanalytical techniques : amperometry, ion selective electrodes and their use."
            ]
          },
          {
            section: "9. Chemical kinetics:",
            points: [
              "Differential and integral rate equations for zeroth, first, second and fractional order reactions; Rate equations involving reverse, parallel, consecutive and chain reactions; Branching chain and explosions; effect of temperature and pressure on rate constant. Study of fast reactions by stop-flow and relaxation methods. Collisions and transition state theories."
            ]
          },
          {
            section: "10. Photochemistry:",
            points: [
              "Absorption of light; decay of excited state by different routes; photochemical reactions between hydrogen and halogens and their quantum yields."
            ]
          },
          {
            section: "11. Surface phenomena and catalysis:",
            points: [
              "Adsorption from gases and solutions on solid adsorbents; Langmuir and B.E.T. adsorption isotherms; determination of surface area, characteristics and mechanism of reaction on heterogeneous catalysts."
            ]
          },
          {
            section: "12. Bio-inorganic chemistry:",
            points: [
              "Metal ions in biological systems and their role in ion-transport across the membranes (molecular mechanism), oxygen-uptake proteins, cytochromes and ferrodoxins."
            ]
          },
          {
            section: "13. Coordination chemistry :",
            points: [
              "a) Bonding in transition of metal complexes. Valence bond theory, crystal field theory and its modifications; applications of theories in the explanation of magnetism and electronic spectra of metal complexes.",
              "b) Isomerism in coordination compounds; IUPAC nomenclature of coordination compounds; stereochemistry of complexes with 4 and 6 coordination numbers; chelate effect and polynuclear complexes; trans effect and its theories; kinetics of substitution reactions in square-planar complexes; thermodynamic and kinetic stability of complexes.",
              "c) EAN rule, Synthesis structure and reactivity of metal carbonyls; carboxylate anions, carbonyl hydrides and metal nitrosyl compounds.",
              "d) Complexes with aromatic systems, synthesis, structure and bonding in metal olefin complexes, alkyne complexes and cyclopentadienyl complexes; coordinative unsaturation, oxidative addition reactions, insertion reactions, fluxional molecules and their characterization; Compounds with metal—metal bonds and metal atom clusters."
            ]
          },
          {
            section: "14. Main Group Chemistry:",
            points: [
              "Boranes, borazines, phosphazenes and cyclic phosphazene, silicates and silicones, Interhalogen compounds; Sulphur—nitrogen compounds, noble gas compounds."
            ]
          },
          {
            section: "15. General Chemistry of ‘f’ Block Element:",
            points: [
              "Lanthanides and actinides: separation, oxidation states, magnetic and spectral properties; lanthanide contraction."
            ]
          }
        ]
      },
      {
        title: "PAPER-II",
        topics: [
          {
            section: "1. Delocalised covalent bonding :",
            points: [
              "Aromaticity, anti-aromaticity; annulenes, azulenes, tropolones, fulvenes, sydnones."
            ]
          },
          {
            section: "2. (a)",
            points: [
              "Reaction mechanisms : General methods (both kinetic and non-kinetic) of study of mechanisms or organic reactions : isotopies, method cross-over experiment, intermediate trapping, stereochemistry; energy of activation; thermodynamic control and kinetic control of reactions.",
              "Reactive intermediates : Generation, geometry, stability and reactions of carboniumions and carbanions, free radicals, carbenes, benzynes and nitrenes.",
              "Substitution reactions :—SN 1, SN 2, and SN i, mechanisms ; neighbouring group participation; electrophilic and nucleophilic reactions of aromatic compounds including heterocyclic compounds—pyrrole, furan, thiophene and indole.",
              "Elimination reactions :—E1, E2 and E1cb mechanisms; orientation in E2 reactions—Saytzeff and Hoffmann; pyrolytic syn elimination—acetate pyrolysis, Chugaev and Cope eliminations.",
              "Addition reactions :—Electrophilic addition to C=C and C□C; nucleophilic addition to C=O, C□N, conjugated olefins and carbonyls.",
              "Reactions and Rearrangements :—(a) Pinacol-pinacolone, Hoffmann, Beckmann, Baeyer-Villiger, Favorskii, Fries, Claisen, Cope, Stevens and Wagner—Meerwein rearrangements."
            ]
          },
          {
            section: "2. (b)",
            points: [
              "Aldol condensation, Claisen condensation, Dieckmann, Perkin, Knoevenagel, Witting, Clemmensen, Wolff-Kishner, Cannizzaro and von Richter reactions; Stobbe, benzoin and acyloin condensations; Fischer indole synthesis, Skraup synthesis, Bischler-Napieralski, Sandmeyer, Reimer-Tiemann and Reformatsky reactions."
            ]
          },
          {
            section: "3. Pericyclic reactions :",
            points: [
              "Classification and examples; Woodward-Hoffmann rules—electrocyclic reactions, cycloaddition reactions [2+2 and 4+2] and sigmatropic shifts [1, 3; 3, 3 and 1, 5], FMO approach."
            ]
          },
          {
            section: "4.",
            points: [
              "a) Preparation and Properties of Polymers: Organic polymerspolyethylene, polystyrene, polyvinyl chloride, teflon, nylon, terylene, synthetic and natural rubber.",
              "b) Biopolymers: Structure of proteins, DNA and RNA."
            ]
          },
          {
            section: "5. Synthetic Uses of Reagents:",
            points: [
              "OsO4, HlO4, CrO3, Pb(OAc)4, SeO2, NBS, B2H6, Na-Liquid NH3, LiAIH4, NaBH4, n-BuLi, MCPBA."
            ]
          },
          {
            section: "6. Photochemistry :",
            points: [
              "Photochemical reactions of simple organic compounds, excited and ground states, singlet and triplet states, Norrish-Type I and Type II reactions."
            ]
          },
          {
            section: "7. Spectroscopy: Principle and applications in structure elucidation :",
            points: [
              "a) Rotational—Diatomic molecules; isotopic substitution and rotational constants.",
              "b) Vibrational—Diatomic molecules, linear triatomic molecules, specific frequencies of functional groups in polyatomic molecules.",
              "c) Electronic—Singlet and triplet states. n→π* and π→π* transitions; application to conjugated double bonds and conjugated carbonyls Woodward-Fieser rules; Charge transfer spectra.",
              "d) Nuclear Magnetic Resonance (1HNMR): Basic principle; chemical shift and spin-spin interaction and coupling constants.",
              "e) Mass Spectrometry :—Parent peak, base peak, metastable peak, McLafferty rearrangement."
            ]
          }
        ]
      }
    ]
  },
  Botony: {
    papers: [
      {
        title: "PAPER-I",
        topics: [
          {
            section: "1. Microbiology and Plant Pathology :",
            points: [
              "Structure and reproduction/multiplication of viruses, viroids, bacteria, fungi and mycoplasma; Applications of microbiology in agriculture, industry, medicine and in control of soil and water pollution; Prion and Prion hypothesis.",
              "Important crop diseases caused by viruses, bacteria, mycoplasma, fungi and nematodes; Modes of infection and dissemination; Molecular basis of infection and disease resistance/defence; Physiology of parasitism and control measures. Fungal toxins. Modelling and disease forecasting; Plant quarantine."
            ]
          },
          {
            section: "2. Cryptogams :",
            points: [
              "Algae, fungi, lichens, bryophytes, pteridophytes-structure and reproduction from evolutionary viewpoint; Distribution of Cryptogams in India and their ecological and economic importance."
            ]
          },
          {
            section: "3. Phanerogams :",
            points: [
              "Gymnosperms : Concept of Progymnosperms. Classification and distribution of gymnosperms. Salient features of Cycadales, Ginkgoales, Coniferales and Gnetales, their structure and reproduction. General account of Cycadofilicales, Bennettitales and Cordiaitailes; Geological time scale; Type of fossils and their study techniques.",
              "Angiosperms : Systematics, anatomy, embryology, palynology and phylogency.",
              "Taxonomic hierarchy; International Code of Botanical Nomenclature; Numerical taxonomy and chemotaxonomy; Evidence from anatomy, embryology and palynology.",
              "Origin and evolution of angiosperms; Comparative account of various systems of classification of angiosperms; Study of angiospermic families— Magnoliaceae, Ranunculaceae, Brassicaceae, Rosaceae, Fabaceae, Euphorbiaceae, Malvaceae, Dipterocarpaceae, Apiaceae, Asclepiadaceae, Verbenaceae, Solanaceae, Rubiaceae, Cucurbitaceae, Asteraceae, Poaceae, Arecaceae, Liliaceae, Musaceae and Orchidaceae.",
              "Stomata and their types; Glandular and non-glandular trichomes; Unusual secondary growth; Anatomy of C3 and C4 plants; Xylem and phloem differentiation; Wood anatomy.",
              "Development of male and female gametophytes, pollination, fertilization; Endosperm—its development and function. Patterns of embryo development; Polyembroyony, apomixes; Applications of palynology; Experimental embryology including pollen storage and test-tube fertilization."
            ]
          },
          {
            section: "4. Plant Resource Development :",
            points: [
              "Domestication and introduction of plants; Origin of cultivated plants, Vavilov’s centres of origin. Plants as sources for food, fodder, fibres, spices, beverages, edible oils, drugs, narcotics, insecticides, timber, gums, resins and dyes; latex, cellulose, starch and its products; Perfumery; Importance of Ethnobotany in Indian context; Energy plantations; Botanical Gardens and Herbaria."
            ]
          },
          {
            section: "5. Morphogenesis :",
            points: [
              "Totipotency, polarity, symmetry and differentiation; Cell, tissue, organ and protoplast culture. Somatic hybrids and Cybrids; Micropropagation; Somaclonal variation and its applications; Pollen haploids, embryo rescue methods and their applications."
            ]
          }
        ]
      },
      {
        title: "PAPER-II",
        topics: [
          {
            section: "1. Cell Biology :",
            points: [
              "Techniques of cell biology. Prokaryotic and eukaryotic cells—structural and ultrastructural details; Structure and function of extracellular matrix (cell wall) and membranes-cell adhesion, membrane transport and vesicular transport; Structure and function of cell organelles (chloroplasts, mitochondria, ER, dictyosomes ribosomes, endosomes,lysosomes, peroxisomes; Cytoskelaton and microtubules; Nucleus, nucleolus, nuclear pore complex; Chromatin and nucleosome; Cell signalling and cell receptors; Signal transduction Mitosis and meiosis; molecular basis of cell cycle. Numerical and structural variations in chromosomes and their significance; Chromatin organization and packaging of genome; Polytene chromosomes; B-chromosomes—structure, behaviour and significance."
            ]
          },
          {
            section: "2. Genetics, Molecular Biology and Evolution :",
            points: [
              "Development of genetics, and gene versus allele concepts (Pseudoalleles); Quantitative genetics and multiple factors; Incomplete dominance, polygenic inheritance, multiple alleles; Linkage and crossing over of gene mapping including molecular maps (idea of mapping, function); Sex chromosomes and sex-linked inheritance; sex determination and molecular basis of sex differentiation; Mutations (biochemical and molecular basis); Cytoplasmic inheritance and cytoplasmic genes (including genetics of male sterility).",
              "Structure and synthesis of nucleic acids and proteins; Genetic code and regulation of gene expression; Gene silencing; Multigene families; Organic evolution-evidences, mechanism and theories.",
              "Role of RNA in origin and evolution."
            ]
          },
          {
            section: "3. Plant Breeding, Biotechnology and Biostatistics :",
            points: [
              "Methods of plant breeding—introduction, selection and hybridization (pedigree, backcross, mass selection, bulk method); Mutation, polyploidy, male sterility and heterosis breeding. Use of apomixes in plant breeding; DNA sequencing; Genetic engineering—methods of transfer of genes; Transgenic crops and biosafety aspects; Development and use of molecular markers in plant breeding; Tools and techniques— probe, southern blotting, DNA fingerprinting, PCR and FISH. Standard deviation and coefficient of variation (CV). Tests of significance (Z-test, t-test and chi-square tests). Probability and distributions (normal, binomial and Poisson). Correlation and regression."
            ]
          },
          {
            section: "4. Physiology and Biochemistry :",
            points: [
              "Water relations, mineral nutrition and ion transport, mineral deficiencies. Photosynthesis— photochemical reactions, photophosphorylation and carbon fixation pathways; C3, C4 and CAM pathways; Mechanism of phloem transport, Respiration (anaerobic and aerobic, including fermentation)—electron transport chain and oxidative phosphorylation; Photorespiration; Chemiosmotic theory and ATP synthesis; Lipid metabolism; Nitrogen fixation and nitrogen metabolism. Enzymes, coenzymes; Energy transfer and energy conservation. Importance of secondary metabolites. Pigments as photoreceptors (plastidial pigments and phytochrome). Plant movements; Photoperiodism and flowering, vernalization, senescence; Growth substances—their chemical nature, role and applications in agri-horticulture; growth indices, growth movements. Stress physiology (heat, water, salinity, metal); Fruit and seed physiology. Dormancy, storage and germination of seed. Fruit ripening—its molecular basis and manipulation."
            ]
          },
          {
            section: "5. Ecology and Plant Geography :",
            points: [
              "Concept of ecosystem; Ecological factors. Concepts and dynamics of community; Plant succession. Concepts of biosphere; Ecosystems; Conservation; Pollution and its control (including phytoremediation); Plant indicators; Environment (Protection) Act.",
              "Forest types of India—‘Ecological and economic importance of forests, afforestation, deforestation and social forestry; Endangered plants, endemism IUCN categories, Red Data Books; Biodiversity and its conservation; Protected Area Network; Convention of Biological Diversity, Farmers’ Rights; and Intellectual Property Rights; Concept of Sustainable Development; Biogeochemical cycles. Global warming and climatic change; Invasive species; Environmental Impact Assessment; Phytogeographical regions of India."
            ]
          }
        ]
      }
    ]
  },
  Philosophy: {
    papers: [
      {
        title: "Paper - I",
        topics: [
          {
            section: "History and Problems of Philosophy",
            points: [
              "Plato and Aristotle : Ideas; Substance; Form and Matter; Causation; Actuality and Potentiality.",
              "Rationalism (Descartes, Spinoza, Leibniz); Cartesian Method and Certain Knowledge; Substance; God; Mind-Body Dualism; Determinism and Freedom.",
              "Empiricism (Locke, Berkeley, Hume) : Theory of Knowledge; Substance and Qualities; Self and God; Scepticism.",
              "Kant: Possibility of Synthetic a priori Judgments; Space and Time; Categories; Ideas of Reason; Antinomies; Critique of Proofs for the Existence of God.",
              "Hegel : Dialectical Method; Absolute Idealism.",
              "Moore, Russell and Early Wittgenstein : Defence of Commonsense; Refutation of Idealism; Logical Atomism; Logical Constructions; Incomplete Symbols; Picture Theory of Meaning; Sying and Showing.",
              "Logical Positivism : Verification Theory of Meaning; Rejection of Metaphysics; Linguistic Theory of Necessary Propositions.",
              "Later Wittgenstein : Meaning and Use; Language-games; Critique of Private Language.",
              "Phenomenology (Husserl): Method; Theory of Essences; Avoidance of Psychologism.",
              "Existentialism (Kierkegaard, Sarte, Heidegger): Existence and Essence; Choice, Responsibility and Authentic Existence; Being-in-the-world and Temporality.",
              "Quine and Strawson : Critique of Empiricism; Theory of Basic Particulars and Persons.",
              "Carvaka : Theory of Knowlegde; Rejection of Transcendent Entities.",
              "Jainism : Theory of Reality; Saptabhanginaya; Bondage and Liberation.",
              "Schools of Buddhism : Prat Ityasamutpada; Ksanikavada, Nairatmyavada.",
              "Nyaya—Vaiesesika : Theory of Categories; Theory of Appearance; Theory of Pramana; Self, Liberation; God; Proofs for the Existence of God; Theory of Causation; Atomistic Theory of Creation.",
              "Samkhya; Prakrit; Purusa; Causation; Liberation.",
              "Yoga; Citta; Cittavrtti; Klesas; Samadhi; Kaivalya.",
              "Mimamsa: Theory of Knowlegde.",
              "Schools of Vedanta : Brahman; Isvara; Atman; Jiva; Jagat; Maya; Avida; Adhyasa; Moksa; Aprthaksiddhi; Pancavidhabheda.",
              "Aurobindo: Evolution, Involution; Integral Yoga."
            ]
          }
        ]
      },
      {
        title: "Paper - II",
        topics: [
          {
            section: "Socio-Political Philosophy",
            points: [
              "Social and Political ldeals : Equality, Justice, Liberty.",
              "Sovereignty : Austin, Bodin, Laski, Kautilya.",
              "Individual and State : Rights; Duties and Accountability.",
              "Forms of Government : Monarchy; Theocracy and Democracy.",
              "Political Ideologies: Anarchism; Marxism and Socialism.",
              "Humanism; Secularism; Multi-culturalism.",
              "Crime and Punishment : Corruption, Mass Violence, Genocide, Capital Punishment.",
              "Development and Social Progress.",
              "Gender Discrimination : Female Foeticide, Land and Property Rights; Empowerment.",
              "Caste Discrimination : Gandhi and Ambedkar."
            ]
          },
          {
            section: "Philosophy of Religion",
            points: [
              "Notions of God : Attributes; Relation to Man and the World. (Indian and Western).",
              "Proofs for the Existence of God and their Critique (Indian and Western).",
              "Problem of  Evil.",
              "Soul : Immortality; Rebirth and Liberation.",
              "Reason, Revelation and Faith.",
              "Religious Experience : Nature and Object (Indian and Western).",
              "Religion without God.",
              "Religion and Morality.",
              "Religious Pluralism and the Problem of Absolute Truth.",
              "Nature of Religious Language : Analogical and Symbolic; Cognitivist and Non-cognitive."
            ]
          }
        ]
      }
    ]
  },
  "Commerce And Accountancy": {
    papers: [
      {
        title: "PAPER-I",
        topics: [
          {
            section: "Accounting and Finance: Accounting, Taxation & Auditing",
            points: []
          },
          {
            section: "Financing Accounting :",
            points: [
              "Accounting as a financial information system; Impact of behavioural sciences. Accounting Standards e.g., accounting for Depreciation, Inventories, Research and Development Costs, Long-term Construction Contracts, Revenue Recognition, Fixed Assets, Contingencies, Foreign Exchange Transactions, Investments and Government Grants, Cash Flow Statement, Earnings per Share.",
              "Accounting for Share Capital Transactions including Bonus Shares, Right Shares.",
              "Employees Stock Option and Buy-Back of Securities.",
              "Preparation and Presentation of Company Final Accounts.",
              "Amalgamations, Absorption and Reconstruction of Companies."
            ]
          },
          {
            section: "Cost Accounting :",
            points: [
              "Nature and functions of cost accounting. Installation of Cost Accounting System. Cost Concepts related to Income Measurement, Profit Planning, Cost Control and Decision Making.",
              "Methods of Costing: Job Costing, Process Costing, Activity Based Costing.",
              "Volume-cost-Profit Relationship as a tool of Profit Planning.",
              "Incremental Analysis/Differential Costing as a Tool of Pricing Decisions, Product Decisions, Make or Buy Decisions, Shut-Down Decisions etc.",
              "Techniques of Cost Control and Cost Reduction : Budgeting as a Tool of Planning and Control. Standard Costing and Variance Analysis.",
              "Responsibility Accounting and Divisional Performance Measurement."
            ]
          },
          {
            section: "Taxation :",
            points: [
              "Income Tax: Definitions. Basis of charge; Incomes which do not form part of total income. Simple problems of computation of income (of individuals only) under various heads, i.e., salaries, income from house property, profits and gains from business or profession, capital gains, income from other sources, Income of other persons included in assessee’s total income.",
              "Set-off and Carry forward of Loss.",
              "Deductions from gross Total Income.",
              "Salient Features/Provisions Related to VAT and Services Tax."
            ]
          },
          {
            section: "Auditing :",
            points: [
              "Company Audit: Audit related to Divisible Profits, Dividends, Special investigations, Tax audit.",
              "Audit of banking, Insurance, Non-Profit Organization and Charitable societies/Trusts/Organizations."
            ]
          },
          {
            section: "Financial Management, Financial Institutions and Markets",
            points: []
          },
          {
            section: "Financial Management :",
            points: [
              "Finance Function : Nature, Scope and Objectives of Financial Management : Risk and Return relationship.",
              "Tools of Financial Analysis: Ratio Analysis, Funds-Flow and Cash-Flow Statement.",
              "Capital Budgeting Decisions: Process, Procedures and Appraisal Methods. Risk and Uncertainty Analysis and Methods.",
              "Cost of Capital : concept, Computation of Specific Costs and Weighted Average Cost of Capital. CAPM as a Tool of Determining Cost of Equity Capital.",
              "Financing Decisions: Theories of Capital Structure—Net Income (NI) Approach.",
              "Net Operating Income (NOI) Approach, MM Approach and Traditional Approach. Designing of Capital structure: Types of Leverages (Operating, Financial and Combined), EBIT-EPS Analysis, and other Factors.",
              "Dividend Decisions and Valuation of Firm : Walter’s Model, MM Thesis, Gordan’s Model Lintner’s Model. Factors Affecting Dividend Policy.",
              "Working Capital Management: Planning of Working Capital. Determinants of Working Capital. Components of Working Capital—Cash, Inventory and Receivables.",
              "Corporate Restructuring with focus on Mergers and Acquisitions (Financial aspect only)."
            ]
          },
          {
            section: "Financial Markets and Institutions :",
            points: [
              "Indian Financial System: An Overview",
              "Money Markets: Participants, Structure and Instruments. Commercial Banks. Reforms in Banking Sector. Monetary and Credit Policy of RBI. RBI as a Regulator.",
              "Capital Market : Primary and Secondary Market. Financial Market Instruments and Innovative Debt Instruments; SEBI as a Regulator.",
              "Financial Services : Mutual Funds, Venture Capital, Credit Rating Agencies, Insurance and IRDA."
            ]
          }
        ]
      },
      {
        title: "PAPER-II",
        topics: [
          {
            section: "Organisation Theory and Behaviours, Human Resource Management and Industrial Relations",
            points: []
          },
          {
            section: "Organisation Theory and Behaviour",
            points: []
          },
          {
            section: "Organisation Theory :",
            points: [
              "Nature and Concept of Organisation; External Environment of Organisation— Technological, Social, Political, Economical and Legal; Organizational Goals Primary and Secondary Goals, Single and Multiple Goals; Management by Objectives.",
              "Evolution of Organisation theory : Classical Neo-classical and system approach.",
              "Modern Concepts of Organisation Theory : Organisational Design, Organisational Structure and Organisational Culture.",
              "Organisational Design—Basic Challenges; Differentiation and Integration Process; Centralization and Decentralization Process; Standardization/Formalization and Mutual Adjustment. Coordinating Formal and Informal Organizations. Mechanistic and Organic Structures.",
              "Designing Organizational structures—Authority and Control; Line and Staff Functions, Specialization and Coordination. Types of Organization Structure—Functional. Matrix Structure, Project Structure. Nature and Basis of Power, Sources of Power, Power Structure and Politics. Impact of Information Technology on Organizational Design and Structure.",
              "Managing Organizational Culture."
            ]
          },
          {
            section: "Organisation Behaviour :",
            points: [
              "Meaning and Concept; Individual in organization: Personality, Theories, and Determinants; Perception Meaning and Process.",
              "Motivation : Concepts, Theories and Applications. Leadership—Theories and Styles. Quality of Work Life (QWL): Meaning and its impact on Performance, Ways of its Enhancement. Quality Circles (QC)—Meaning and their Importance. Management of Conflicts in Organizations. Transactional Analysis, Organizational Effectiveness, Management of Change."
            ]
          },
          {
            section: "Human Resources Management and Industrial Relations",
            points: []
          },
          {
            section: "Human Resources Management (HRM) :",
            points: [
              "Meaning Nature and Scope of HRM, Human Resource Planning, Job Analysis, Job Description, Job Specification, Recruitment Process, Selection Process, Orientational and Placement, Training and Development Process, Performance Appraisal and 360° Feed Back, Salary and Wage Administration, Job Evaluation, Employee Welfare, Promotions, Transfers and Separations."
            ]
          },
          {
            section: "Industrial Relations (IR) :",
            points: [
              "Meaning, Nature, Importance and Scope of IR, Formation of Trade Union, Trade Union Legislation, Trade Union Movement in India. Recognition of Trade Unions, Problems of Trade Unions in India.",
              "Impact of Liberalization on Trade Union Movement.",
              "Nature of Industrial Disputes: Strikes and Lockouts, Causes of Disputes, Prevention and Settlement of Disputes.",
              "Worker’s Participation in Management: Philosophy, Rationale, Present Day Status and future Prospects.",
              "Adjudication and Collective Bargaining.",
              "Industrial Relations in Public Enterprises Absenteeism and Labour Turnover in Indian Industries and their Causes and Remedies.",
              "ILO and its Functions."
            ]
          }
        ]
      }
    ]
  },
  History: {
    papers: [
      {
        title: "PAPER - I",
        topics: [
          {
            section: "1. Sources:",
            points: [
              "Archaeological sources: Exploration, excavation, epigraphy, numismatics, monuments",
              "Literary sources: Indigenous: Primary and secondary; poetry, scientific literature, literature, literature in regional languages, religious literature.",
              "Foreign accounts: Greek, Chinese and Arab writers."
            ]
          },
          {
            section: "2. Pre-history and Proto-history:",
            points: [
              "Geographical factors; hunting and gathering (paleolithic and mesolithic); Beginning of agriculture (Neolithic and chalcolithic)."
            ]
          },
          {
            section: "3. Indus Valley Civilization:",
            points: [
              "Origin, date, extent, characteristics, decline, survival and significance, art and architecture."
            ]
          },
          {
            section: "4. Megalithic Cultures:",
            points: [
              "Distribution of pastoral and farming cultures outside the Indus, Development of community life, Settlements, Development of agriculture, Crafts, Pottery, and Iron industry."
            ]
          },
          {
            section: "5. Aryans and Vedic Period:",
            points: [
              "Expansions of Aryans in India:",
              "Vedic Period: Religious and philosophic literature; Transformation from Rig Vedic period to the later Vedic period; Political, social and economical life; Significance of the Vedic Age; Evolution of Monarchy and Varna system."
            ]
          },
          {
            section: "6. Period of Mahajanapadas:",
            points: [
              "Formation of States (Mahajanapada) : Republics and monarchies; Rise of urban centres; Trade routes; Economic growth; Introduction of coinage; Spread of Jainism and Buddhism; Rise of Magadha and Nandas. Iranian and Macedonian invasions and their impact."
            ]
          },
          {
            section: "7. Mauryan Empire:",
            points: [
              "Foundation of the Mauryan Empire, Chandragupta, Kautilya and Arthashastra; Ashoka; Concept of Dharma; Edicts; Polity, Administration; Economy; Art, architecture and sculpture; External contacts; Religion; Spread of religion; Literature.",
              "Disintegration of the empire; Sungas and Kanvas."
            ]
          },
          {
            section: "8. Post - Mauryan Period (Indo-Greeks, Sakas, Kushanas, Western Kshatrapas):",
            points: [
              "Contact with outside world; growth of urban centres, economy, coinage, development of religions, Mahayana, social conditions, art, architecture, culture, literature and science."
            ]
          },
          {
            section: "9. Early State and Society in Eastern India, Deccan and South India:",
            points: [
              "Kharavela, The Satavahanas, Tamil States of the Sangam Age; Administration, economy, land grants, coinage, trade guilds and urban centres; Buddhist centres; Sangam literature and culture; Art and architecture."
            ]
          },
          {
            section: "10. Guptas, Vakatakas and Vardhanas:",
            points: [
              "Polity and administration, Economic conditions, Coinage of the Guptas, Land grants, Decline of urban centres, Indian feudalism, Caste system, Position of women, Education and educational institutions; Nalanda, Vikramshila and Vallabhi, Literature, scientific literature, art and architecture."
            ]
          },
          {
            section: "11. Regional States during Gupta Era:",
            points: [
              "The Kadambas, Pallavas, Chalukyas of Badami; Polity and Administration, Trade guilds, Literature; growth of Vaishnava and Saiva religions. Tamil Bhakti movement, Shankaracharya; Vedanta; Institutions of temple and temple architecture; Palas, Senas, Rashtrakutas, Paramaras, Polity and administration; Cultural aspects. Arab conquest of Sind; Alberuni, The Chalukyas of Kalyana, Cholas, Hoysalas, Pandyas; Polity and Administration; local Government; Growth of art and architecture, religious sects, Institution of temple and Mathas, Agraharas, education and literature, economy and society."
            ]
          },
          {
            section: "12. Themes in Early Indian Cultural History:",
            points: [
              "Languages and texts, major stages in the evolution of art and architecture, major philosophical thinkers and schools, ideas in Science and Mathematics."
            ]
          },
          {
            section: "13. Early Medieval India, 750-1200:",
            points: [
              "Polity: Major political developments in Northern India and the Peninsula, origin and the rise of Rajputs.",
              "The Cholas: administration, village economy and society “Indian Feudalism”",
              "Agrarian economy and urban settlements",
              "Trade and commerce",
              "Society: the status of the Brahman and the new social order",
              "Condition of women",
              "Indian science and technology"
            ]
          },
          {
            section: "14. Cultural Traditions in India, 750-1200:",
            points: [
              "Philosophy: Skankaracharya and Vedanta, Ramanuja and Vishishtadvaita, Madhva and Brahma-Mimansa",
              "Religion: Forms and features of religion, Tamil devotional cult, growth of Bhakti, Islam and its arrival in India, Sufism",
              "Literature: Literature in Sanskrit, growth of Tamil literature, literature in the newly developing languages, Kalhan’s Rajtarangini, Alberuni’s India",
              "Art and Architecture: Temple architecture, sculpture, painting"
            ]
          },
          {
            section: "15. The Thirteenth Century:",
            points: [
              "Establishment of the Delhi Sultanate: The Ghurian invasions – factors behind Ghurian success",
              "Economic, social and cultural consequences",
              "Foundation of Delhi Sultanate and early Turkish Sultans",
              "Consolidation: The rule of Iltutmish and Balban"
            ]
          },
          {
            section: "16. The Fourteenth Century:",
            points: [
              "“The Khalji Revolution”",
              "Alauddin Khalji: Conquests and territtorial expansion, agrarian and economic measures",
              "Muhammad Tughluq: Major projects, agrarian measures, bureaucracy of Muhammad Tughluq",
              "Firuz Tughluq: Agrarian measures, achievements in civil engineering and public works, decline of the Sultanate, foreign contacts and Ibn Battuta’s account."
            ]
          },
          {
            section: "17. Society, Culture and Economy in the Thirteenth and Fourteenth Centuries:",
            points: [
              "Society: composition of rural society, ruling classes, town dwellers, women, religious classes, caste and slavery under the Sultanate, Bhakti movement, Sufi movement",
              "Culture: Persian literature, literature in the regional languages of North India, literature in the languages of South India, Sultanate architecture and new structural forms, painting, evolution of a composite culture",
              "Economy: Agricultural production, rise of urban economy and non-agricultural production, trade and commerce"
            ]
          },
          {
            section: "18. The Fifteenth and Early Sixteenth Century – Political Developments and Economy:",
            points: [
              "Rise of Provincial Dynasties: Bengal, Kashmir (Zainul Abedin), Gujarat.",
              "Malwa, Bahmanids",
              "The Vijayanagra Empire",
              "Lodis",
              "Mughal Empire, First phase: Babur and Humayun",
              "The Sur Empire: Sher Shah’s administration",
              "Portuguese Colonial enterprise, Bhakti and Sufi Movements"
            ]
          },
          {
            section: "19. The Fifteenth and early Sixteenth Century – Society and Culture:",
            points: [
              "Regional cultural specificities",
              "Literary traditions",
              "Provincial architecture",
              "Society, culture, literature and the arts in Vijayanagara Empire."
            ]
          },
          {
            section: "20. Akbar:",
            points: [
              "Conquests and consolidation of the Empire",
              "Establishment of Jagir and Mansab systems",
              "Rajput policy",
              "Evolution of religious and social outlook, theory of Sulh-i-kul and religious policy",
              "Court patronage of art and technology"
            ]
          },
          {
            section: "21. Mughal Empire in the Seventeenth Century:",
            points: [
              "Major administrative policies of Jahangir, Shahjahan and Aurangzeb",
              "The Empire and the Zamindars",
              "Religious policies of Jahangir, Shahjahan and Aurangzeb",
              "Nature of the Mughal State",
              "Late Seventeenth century crisis and the revolts",
              "The Ahom Kingdom",
              "Shivaji and the early Maratha Kingdom."
            ]
          },
          {
            section: "22. Economy and Society in the Sixteenth and Seventeenth Centuries:",
            points: [
              "Population, agricultural production, craft production",
              "Towns, commerce with Europe through Dutch, English and French companies : a trade revolution",
              "Indian mercantile classes, banking, insurance and credit systems",
              "Condition of peasants, condition of women",
              "Evolution of the Sikh community and the Khalsa Panth"
            ]
          },
          {
            section: "23. Culture in the Mughal Empire:",
            points: [
              "Persian histories and other literature",
              "Hindi and other religious literature",
              "Mughal architecture",
              "Mughal painting",
              "Provincial architecture and painting - Classical music",
              "Science and technology"
            ]
          },
          {
            section: "24. The Eighteenth Century:",
            points: [
              "Factors for the decline of the Mughal Empire",
              "The regional principalities: Nizam’s Deccan, Bengal, Awadh",
              "Maratha ascendancy under the Peshwas",
              "The Maratha fiscal and financial system",
              "Emergence of Afghan Power, Battle of Panipat:1761",
              "State of politics, culture and economy on the eve of the British conquest"
            ]
          }
        ]
      },
      {
        title: "PAPER - II",
        topics: [
          {
            section: "1. European Penetration into India:",
            points: [
              "The Early European Settlements; The Portuguese and the Dutch; The English and the French East India Companies; Their struggle for supremacy; Carnatic Wars; Bengal -The conflict between the English and the Nawabs of Bengal; Siraj and the English; The Battle of Plassey; Significance of Plassey."
            ]
          },
          {
            section: "2. British Expansion in India:",
            points: [
              "Bengal – Mir Jafar and Mir Kasim; The Battle of Buxar; Mysore; The Marathas; The three Anglo-Maratha Wars; The Punjab."
            ]
          },
          {
            section: "3. Early Structure of the British Raj:",
            points: [
              "The early administrative structure; From diarchy to direct control; The Regulating Act (1773); The Pitt’s India Act (1784); The Charter Act (1833); The voice of free trade and the changing character of British colonial rule; The English utilitarian and India."
            ]
          },
          {
            section: "4. Economic Impact of British Colonial Rule:",
            points: [
              "Land revenue settlements in British India; The Permanent Settlement; Ryotwari Settlement; Mahalwari Settlement; Economic impact of the revenue arrangements; Commercialization of agriculture; Rise of landless agrarian labourers; Impoverishment of the rural society.",
              "Dislocation of traditional trade and commerce; De-industrialisation; Decline of traditional crafts; Drain of wealth; Economic transformation of India; Railroad and communication network including telegraph and postal services; Famine and poverty in the rural interior; European business enterprise and its limitations."
            ]
          },
          {
            section: "5. Social and Cultural Developments:",
            points: [
              "The state of indigenous education, its dislocation; Orientalist-Anglicist controversy, The introduction of western education in India; The rise of press, literature and public opinion; The rise of modern vernacular literature; Progress of science; Christian missionary activities in India."
            ]
          },
          {
            section: "6. Social and Religious Reform movements in Bengal and Other Areas:",
            points: [
              "Ram Mohan Roy, The Brahmo Movement; Devendranath Tagore; Iswarchandra Vidyasagar; The Young Bengal Movement; Dayanada Saraswati; The social reform movements in India including Sati, widow remarriage, child marriage etc.; The contribution of Indian renaissance to the growth of modern India; Islamic revivalism – the Feraizi and Wahabi Movements."
            ]
          },
          {
            section: "7. Indian Response to British Rule:",
            points: [
              "Peasant movements and tribal uprisings in the 18th and 19th centuries including the Rangpur Dhing (1783), the Kol Rebellion (1832), the Mopla Rebellion in Malabar (1841-1920), the Santal Hul (1855), Indigo Rebellion (1859-60), Deccan Uprising (1875) and the Munda Ulgulan (18991900); The Great Revolt of 1857 - Origin, character, causes of failure, the consequences; The shift in the character of peasant uprisings in the post-1857 period; the peasant movements of the 1920s and 1930s."
            ]
          },
          {
            section: "8. Factors leading to the birth of Indian Nationalism;",
            points: [
              "Politics of Association; The Foundation of the Indian National Congress; The Safety-valve thesis relating to the birth of the Congress; Programme and objectives of Early Congress; the social composition of early Congress leadership; the Moderates and Extremists; The Partition of Bengal (1905); The Swadeshi Movement in Bengal; the economic and political aspects of Swadeshi Movement; The beginning of revolutionary extremism in India."
            ]
          },
          {
            section: "9. Rise of Gandhi;",
            points: [
              "Character of Gandhian nationalism; Gandhi’s popular appeal; Rowlatt Satyagraha; the Khilafat Movement; the Non-cooperation Movement; National politics from the end of the Non-cooperation movement to the beginning of the Civil Disobedience movement; the two phases of the Civil Disobedience Movement; Simon Commission; The Nehru Report; the Round Table Conferences; Nationalism and the Peasant Movements; Nationalism and Working class movements; Women and Indian youth and students in Indian politics (1885-1947); the election of 1937 and the formation of ministries; Cripps Mission; the Quit India Movement; the Wavell Plan; The Cabinet Mission."
            ]
          },
          {
            section: "10. Constitutional Developments in the Colonial India between 1858 and 1935.",
            points: []
          },
          {
            section: "11. Other strands in the National Movement.",
            points: [
              "The Revolutionaries: Bengal, the Punjab, Maharashtra, U.P, the Madras Presidency, Outside India.",
              "The Left; The Left within the Congress: Jawaharlal Nehru, Subhas Chandra Bose, the Congress Socialist Party; the Communist Party of India, other left parties."
            ]
          },
          {
            section: "12. Politics of Separatism;",
            points: [
              "the Muslim League; the Hindu Mahasabha; Communalism and the politics of partition; Transfer of power; Independence."
            ]
          },
          {
            section: "13. Consolidation as a Nation;",
            points: [
              "Nehru’s Foreign Policy; India and her neighbours (1947-1964); The linguistic reorganization of States (1935-1947); Regionalism and regional inequality; Integration of Princely States; Princes in electoral politics; the Question of National Language."
            ]
          },
          {
            section: "14. Caste and Ethnicity after 1947;",
            points: [
              "Backward castes and tribes in postcolonial electoral politics; Dalit movements."
            ]
          },
          {
            section: "15. Economic development and political change;",
            points: [
              "Land reforms; the politics of planning and rural reconstruction; Ecology and environmental policy in post – colonial India; Progress of science."
            ]
          },
          {
            section: "16. Enlightenment and Modern ideas:",
            points: [
              "Major ideas of Enlightenment: Kant, Rousseau",
              "Spread of Enlightenment in the colonies",
              "Rise of socialist ideas (up to Marx); spread of Marxian Socialism."
            ]
          },
          {
            section: "17. Origins of Modern Politics:",
            points: [
              "European States System.",
              "American Revolution and the Constitution.",
              "French revolution and aftermath, 1789-1815.",
              "American Civil War with reference to Abraham Lincoln and the abolition of slavery.",
              "British Democratic Politics, 1815-1850; Parliamentary Reformers, Free Traders, Chartists."
            ]
          },
          {
            section: "18. Industrialization:",
            points: [
              "English Industrial Revolution: Causes and Impact on Society",
              "Industrialization in other countries: USA, Germany, Russia, Japan",
              "Industrialization and Globalization."
            ]
          },
          {
            section: "19. Nation-State System:",
            points: [
              "Rise of Nationalism in 19th century",
              "Nationalism: state-building in Germany and Italy",
              "Disintegration of Empires in the face of the emergence of nationalities across the world."
            ]
          },
          {
            section: "20. Imperialism and Colonialism:",
            points: [
              "South and South-East Asia",
              "Latin America and South Africa",
              "Australia",
              "Imperialism and free trade: Rise of neo-imperialism."
            ]
          },
          {
            section: "21. Revolution and Counter-Revolution:",
            points: [
              "th Century European revolutions",
              "The Russian Revolution of 1917-1921",
              "Fascist Counter-Revolution, Italy and Germany.",
              "The Chinese Revolution of 1949"
            ]
          },
          {
            section: "22. World Wars:",
            points: [
              "st and 2nd World Wars as Total Wars: Societal implications",
              "World War I: Causes and consequences",
              "World War II: Causes and consequence"
            ]
          },
          {
            section: "23. The World after World War II:",
            points: [
              "Emergence of two power blocs",
              "Emergence of Third World and non-alignment",
              "UNO and the global disputes."
            ]
          },
          {
            section: "24. Liberation from Colonial Rule:",
            points: [
              "Latin America-Bolivar",
              "Arab World-Egypt",
              "Africa-Apartheid to Democracy",
              "South-East Asia-Vietnam"
            ]
          },
          {
            section: "25. Decolonization and Underdevelopment:",
            points: [
              "Factors constraining development: Latin America, Africa"
            ]
          },
          {
            section: "26. Unification of Europe:",
            points: [
              "Post War Foundations: NATO and European Community",
              "Consolidation and Expansion of European Community",
              "European Union."
            ]
          },
          {
            section: "27. Disintegration of Soviet Union and the Rise of the Unipolar World:",
            points: [
              "Factors leading to the collapse of Soviet communism and the Soviet Union, 1985-1991",
              "Political Changes in Eastern Europe 1989-2001.",
              "End of the cold war and US ascendancy in the World as the lone superpower."
            ]
          }
        ]
      }
    ]
  },
  "Public Administration": {
    papers: [
      {
        title: "Paper - I : Administrative Theory",
        topics: [
          {
            section: "Introduction:",
            points: [
              "Meaning, scope and significance of Public Administration, Wilson’s vision of Public Administration, Evolution of the discipline and its present status. New Public Administration, Public Choice approach; Challenges of liberalization, Privatisation, Globalisation; Good Governance: concept and application; New Public Management."
            ]
          },
          {
            section: "Administrative Thought:",
            points: [
              "Scientific Management and Scientific Management movement; Classical Theory; Weber’s bureaucratic model its critique and post-Weberian Developments; Dynamic Administration (Mary Parker Follett); Human Relations School (Elton Mayo and others); Functions of the Executive (C.I. Barnard); Simon’s decision making theory; Participative Management (R. Likert, C. Argyris, D. McGregor.)"
            ]
          },
          {
            section: "Administrative Behaviour:",
            points: [
              "Process and techniques of decision-making; Communication; Morale; Motivation Theories content, process and contemporary; Theories of Leadership: Traditional and Modem."
            ]
          },
          {
            section: "Organisations:",
            points: [
              "Theories systems, contingency; Structure and forms: Ministries and Departments, Corporations, Companies; Boards and Commissions; Ad hoc, and advisory bodies; Headquarters and Field relationships; Regulatory Authorities; Public-Private Partnerships."
            ]
          },
          {
            section: "Accountability and Control:",
            points: [
              "Concepts of accountability and control; Legislative, Executive and judicial control over administration; Citizen and Administration; Role of media, interest groups, voluntary organizations; Civil society; Citizen’s Charters; Right to Information; Social audit."
            ]
          },
          {
            section: "Administrative Law:",
            points: [
              "Meaning, scope and significance; Dicey on Administrative law; Delegated legislation; Administrative Tribunals."
            ]
          },
          {
            section: "Comparative Public Administration:",
            points: [
              "Historical and sociological factors affecting administrative systems; Administration and politics in different countries; Current status of Comparative Public Administration; Ecology and administration; Riggsian models and their critique."
            ]
          },
          {
            section: "Development Dynamics:",
            points: [
              "Concept of development; Changing profile of development administration; ‘Anti-development thesis’; Bureaucracy and development; Strong state versus the market debate; Impact of liberalisation on administration in developing countries; Women and development the self-help group movement."
            ]
          },
          {
            section: "Personnel Administration:",
            points: [
              "Importance of human resource development; Recruitment, training, career advancement, position classification, discipline, performance appraisal, promotion, pray and service conditions; employer employee relations, grievance redressal mechanism; Code of conduct; Administrative ethics."
            ]
          },
          {
            section: "Public Policy:",
            points: [
              "Models of policy-making and their critique; Processes of conceptualisation, planning, implementation, monitoring, evaluation and review and their limitations; State theories and public policy formulation."
            ]
          },
          {
            section: "Techniques of Administrative Improvement:",
            points: [
              "Organisation and methods, Work study and work management; e-governance and information technology; Management aid tools like network analysis, MIS, PERT, CPM."
            ]
          },
          {
            section: "Financial Administration:",
            points: [
              "Monetary and fiscal policies: Public borrowings and public debt Budgets types and forms; Budgetary process; Financial accountability; Accounts and audit."
            ]
          }
        ]
      },
      {
        title: "Paper - II : Indian Administration",
        topics: [
          {
            section: "Evolution of Indian Administration:",
            points: [
              "Kautilya Arthashastra; Mughal administration; Legacy of British rule in politics and administration Indianization of Public services, revenue administration, district Administration, local self Government."
            ]
          },
          {
            section: "Philosophical and Constitutional framework of Government:",
            points: [
              "Salient features and value premises; Constitutionalism; Political culture; Bureaucracy and democracy; Bureaucracy and development."
            ]
          },
          {
            section: "Public Sector Undertakings:",
            points: [
              "Public sector in modern India; Forms of Public Sector Undertakings; Problems of autonomy, accountability and control; Impact of liberalization and privatization."
            ]
          },
          {
            section: "Union Government and Administration:",
            points: [
              "Executive, Parliament, Judiciary-structure, functions, work processes; Recent trends; Intra governmental relations; Cabinet Secretariat; Prime Minister’s Office; Central Secretariat; Ministries and Departments; Boards; Commissions; Attached offices; Field organizations."
            ]
          },
          {
            section: "Plans and Priorities:",
            points: [
              "Machinery of planning; Role, composition and functions of the Planning Commission and the National Development Council; ‘Indicative’ planning; Process of plan formulation at Union and State levels; Constitutional Amendments (1992) and decentralized planning for economic development and social justice."
            ]
          },
          {
            section: "State Government and Administration:",
            points: [
              "Union-State administrative, legislative and financial relations; Role of the Finance Commission; Governor; Chief Minister; Council of Ministers; Chief Secretary; State Secretariat; Directorates."
            ]
          },
          {
            section: "District Administration since Independence:",
            points: [
              "Changing role of the Collector; Union-State-local relations; Imperatives of development management and law and order administration; District administration and democratic decentralization."
            ]
          },
          {
            section: "Civil Services:",
            points: [
              "Constitutional position; Structure, recruitment, training and capacity building; Good governance initiatives; Code of conduct and discipline; Staff associations; Political rights; Grievance redressal mechanism; Civil service neutrality; Civil service activism."
            ]
          },
          {
            section: "Financial Management:",
            points: [
              "Budget as a political instrument; Parliamentary control of public expenditure; Role of finance ministry in monetary and fiscal area; Accounting techniques; Audit; Role of Controller General of Accounts and Comptroller and Auditor General of India."
            ]
          },
          {
            section: "Administrative Reforms since Independence:",
            points: [
              "Major concerns; Important Committees and Commissions; Reforms in financial management and human resource development; Problems of implementation."
            ]
          },
          {
            section: "Rural Development:",
            points: [
              "Institutions and agencies since Independence; Rural development programmes: foci and strategies; Decentralization and Panchayati Raj; 73rd Constitutional amendment."
            ]
          },
          {
            section: "Urban Local Government:",
            points: [
              "Municipal governance: main features, structures, finance and problem areas; 74th Constitutional Amendment; Global-local debate; New localism; Development dynamics, politics and administration with special reference to city management."
            ]
          },
          {
            section: "Law and Order Administration:",
            points: [
              "British legacy; National Police Commission; Investigative agencies; Role of Central and State Agencies including para military forces in maintenance of law and order and countering insurgency and terrorism; Criminalisation of politics and administration; Police-public relations; Reforms in Police."
            ]
          },
          {
            section: "Significant issues in Indian Administration:",
            points: [
              "Values in public service; Regulatory Commissions; National Human Rights Commission; Problems of administration in coalition regimes; Citizen administration interface; Corruption and administration; Disaster management."
            ]
          }
        ]
      }
    ]
  },
  PSIR: {
    papers: [
      {
        title: "Paper - I",
        topics: [
          {
            section: "1. Political Theory and Indian Politics:",
            points: [
              "Political Theory: meaning and approaches.",
              "Theories of state: Liberal, Neo-liberal, Marxist, Pluiralist, post-colonial and Feminist.",
              "Justice: Conceptions of justice with special reference to Rawl’s theory of justice and its communitarian critiques.",
              "Equality: Social, political and economic; relationship between equality and freedom; Affirmative action.",
              "Rights: Meaning and theories; different kinds of rights; Concept of Human Rights.",
              "Democracy: Classical and contemporary theories; different models of democracy—representative, participatory and deliberative.",
              "Concept of power: hegemony, ideology and legitimacy.",
              "Political Ideologies: Liberalism, Socialism, Marxism, Fascism, Gandhism and Feminism.",
              "Indian Political Thought: Dharamshastra,Arthashastra and Buddhist Traditions; Sir Syed Ahmed Khan, Sri Aurobindo, M. K. Gandhi, B. R. Ambedkar, M. N. Roy.",
              "Western Political Thought: Plato, Aristotle, Machiavelli, Hobbes, Locke, John S. Mill, Marx, Gramsci, Hannah Arendt."
            ]
          },
          {
            section: "2. Indian Government and Politics",
            points: [
              {
                title: "2.1 Indian Nationalism: ",
                subpoints: [
                  "Political Strategies of India’s Freedom Struggle: Constitutionalism to mass Satyagraha, Non-cooperation, Civil Disobedience; Militant and Revolutionary Movements, Peasant and Workers Movements.",
                  "Perspectives on Indian National Movement; Liberal, Socialist and Marxist; Radical Humanist and Dalit."
                ]
              },
              {
                title: "2.2 Making of the Indian Constitution:",
                subpoints: [
                  "Legacies of the British rule; different social and political perspectives."
                ]
              },
              {
                title: "2.3 Salient Features of the Indian Constitution:",
                subpoints: [
                  "The Preamble, Fundamental Rights and Duties, Directive Principles; Parliamentary System and Amendment Procedures; Judicial Review and Basic Structure doctrine."
                ]
              },
              {
                subpoints: [
                  "Principal Organs of the Union Government: Envisaged role and actual working of the Executive, Legislature and Supreme Court.",
                  "Principal Organs of the State Government: Envisaged role and actual working of the Executive, Legislature and High Courts."
                ]
              },
              {
                title: "2.4 Grassroots Democracy:",
                subpoints: [
                  "Panchayati Raj and Municipal Government; Significance of 73rd and 74th Amendments; Grassroot movements."
                ]
              },
              {
                title: "2.5Statutory Institutions/Commissions:",
                subpoints: [
                  "Election Commission, Comptroller and Auditor General, Finance Commission, Union Public Service Commission, National Commission for Scheduled Castes, National Commission for Scheduled Tribes, National Commission for Women; National Human Rights Commission, National Commission for Minorities, National Backward Classes Commission."
                ]
              },
              {
                title: "2.6 Federalism:",
                subpoints: [
                  "Constitutional provisions; changing nature of centre-state relations; integrationist tendencies and regional aspirations; inter-state disputes."
                ]
              },
              {
                title: "2.7 Planning and Economic development:",
                subpoints: [
                  "Nehruvian and Gandhian perspectives; Role of planning and public sector; Green Revolution, land reforms and agrarian relations; liberalization and economic reforms."
                ]
              },
              {
                subpoints: [
                  "Caste, Religion and Ethnicity in Indian Politics."
                ]
              },
              {
                title: "2.8 Party System:",
                subpoints: [
                  "National and regional political parties, ideological and social bases of parties; Patterns of coalition politics; Pressure groups, trends in electoral behaviour; changing socio-economic profile of Legislators."
                ]
              },
              {
                title: "2.9Social Movement: ",
                subpoints: [
                  "Civil liberties and human rights movements; women’s movements; environmentalist movements."
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Paper - II : Comparative Politics and International Relations ",
        topics: [
          {
            section: "1.1 Comparative Political Analysis and International Politics:",
            points: [
              {
                subpoints: [
                  "Comparative Politics: Nature and major approaches; Political economy and political sociology perspectives; Limitations of the comparative method."
                ]
              },
              {
                subpoints: [
                  "State in Comparative Perspective: Characteristics and changing nature of the State in capitalist and socialist economies, and advanced industrial and developing societies."
                ]
              },
              {
                subpoints: [
                  "Politics of Representation and Participation: Political parties, pressure groups and social movements in advanced industrial and developing societies."
                ]
              },
              {
                subpoints: [
                  "Globalisation: Responses from developed and developing societies."
                ]
              },
              {
                subpoints: [
                  "Approaches to the Study of International Relations: Idealist, Realist, Marxist, Functionalist and Systems theory."
                ]
              },
              {
                subpoints: [
                  "Key Concepts in International Relations: National interest, security and power; Balance of power and deterrence; Transitional actors and collective security; World capitalist economy and globalisation."
                ]
              },
              {
                title: "1.2 Changing International Political Order : ",
                subpoints: [
                  "Rise of super powers; Strategic and ideological Bipolarity, arms race and cold war; Nuclear threat;",
                  "Non-aligned Movement: Aims and achievements.",
                  "Collapse of the Soviet Union; Unipolarity and American hegemony; Relevance of non-alignment in the contemporary world."
                ]
              },
              {
                subpoints: [
                  "Evolution of the International Economic System: From Bretton woods to WTO; Socialist economies and the CMEA (Council for Mutual Economic Assistance); Third World demand for new international economic order; Globalisation of the world economy."
                ]
              },
              {
                subpoints: [
                  "United Nations: Envisaged role and actual record; Specialized UN agencies—aims and functioning; need for UN reforms."
                ]
              },
              {
                subpoints: [
                  "Regionalisation of World Politics: EU, ASEAN, APEC, AARC, NAFTA."
                ]
              },
              {
                subpoints: [
                  "Contemporary Global Concerns: Democracy, human rights, environment, gender justice terrorism, nuclear proliferation."
                ]
              }
            ]
          },
          {
            section: "2.1 India and the World",
            points: [
              {
                subpoints: [
                  "Indian Foreign Policy: Determinants of foreign policy; the institutions of policy-making; Continuity and change."
                ]
              },
              {
                subpoints: [
                  "India’s Contribution to the Non-Alignment Movement Different phases; Current role."
                ]
              },
              {
                title: "2.2 India and South Asia: ",
                subpoints: [
                  "Regional Co-operation: SAARC-past performance and future prospects.",
                  "South Asia as a Free Trade Area.",
                  "India’s “Look East” policy.",
                  "Impediments to regional co-operation: River water disputes; illegal cross border migration; Ethnic conflicts and insurgencies; Border disputes."
                ]
              },
              {
                subpoints: [
                  "India and the Global South: Relations with Africa and Latin America; Leadership role in the demand for NIEO and WTO negotiations."
                ]
              },
              {
                subpoints: [
                  "India and the Global Centres of Power: USA, EU, Japan, China and Russia."
                ]
              },
              {
                subpoints: [
                  "India and the UN System: Role in UN Peace-keeping; Demand for Permanent Seat in the Security Council."
                ]
              },
              {
                subpoints: [
                  "India and the Nuclear Question: Changing perceptions and policy."
                ]
              },
              {
                subpoints: [
                  "Recent developments in Indian Foreign Policy: India’s position on the recent crises in Afghanistan, Iraq and West Asia, growing relations with US and Isreal; Vision of a new world order."
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  Psychology: {
    papers: [
      {
        title: "PAPER - I: Foundations of Psychology",
        topics: [
          {
            section: "1. Introduction:",
            points: [
              "Definition of Psychology; Historical antecedents of Psychology and trends in the 21st century; Psychology and scientific methods; Psychology in relation to other social sciences and natural sciences; Application of Psychology to societal problems."
            ]
          },
          {
            section: "2. Methods of Psychology:",
            points: [
              "Types of research: Descriptive, evaluative, diagnostic and prognostic; Methods of Research: Survey, observation, case-study and experiments; Characteristics of experimental design and non-experimental design, Quasi-experimental designs; Focussed group discussions, brain storming, grounded theory approach."
            ]
          },
          {
            section: "3. Research Methods:",
            points: [
              "Major steps in Psychological research (problem statement, hypothesis formulation, research designs, sampling, tools of data collection, analysis and interpretation and report writing) Fundamental versus applied research; Methods of data collection (interview, observation, questionnaire and case study); Research designs (ex-post facto and experimental); Application of statistical technique (t - test, two way ANOVA correlation, regression and factor analysis); Item response theory."
            ]
          },
          {
            section: "4. Development of Human Behaviour:",
            points: [
              "Growth and development; Principles of development, Role of genetic and environmental factors in determining human behaviour; Influence of cultural factors in socialization; Life span development Characteristics, development tasks, promoting psychological well-being across major stages of the life span."
            ]
          },
          {
            section: "5. Sensation, Attention and Perception:",
            points: [
              "Sensation: concepts of threshold, absolute and difference thresholds, signal-detection and vigilance; Factors influencing attention including set and characteristics of stimulus; Definition and concept of perception, biological factors in perception; Perceptual organization-influence of past experiences, perceptual defence- factors influencing space and depth perception, size estimation and perceptual readiness; The plasticity of perception; Extrasensory perception; Culture and perception, Subliminal perception."
            ]
          },
          {
            section: "6. Learning:",
            points: [
              "Concept and theories of learning (Behaviourists, Gestaltalist and Information processing models); The Processes of extinction, discrimination and generalization; Programmed learning, probability learning, self-instructional learning, concepts; Types and the schedules of reinforcement, escape, avoidance and punishment, modeling and social learning."
            ]
          },
          {
            section: "7. Memory:",
            points: [
              "Encoding and remembering; Short term memory, Long term memory, Sensory memory, Iconic memory, Echoic memory: The Multistore model, levels of processing; Organization and Mnemonic techniques to improve memory; Theories of forgetting: decay, interference and retrieval failure: Metamemory; Amnesia: Anterograde and retrograde."
            ]
          },
          {
            section: "8. Thinking and Problem Solving:",
            points: [
              "Piaget’s theory of cognitive development; Concept formation processes; Information processing, Reasoning and problem solving, Facilitating and hindering factors in problem solving, Methods of problem solving: Creative thinking and fostering creativity; Factors influencing decision making and judgment; Recent trends."
            ]
          },
          {
            section: "9. Motivation and Emotion:",
            points: [
              "Psychological and physiological basis of motivation and emotion; Measurement of motivation and emotion; Effects of motivation and emotion on behaviour; Extrinsic and intrinsic motivation; Factors influencing intrinsic motivation; Emotional competence and the related issues."
            ]
          },
          {
            section: "10. Intelligence and Aptitude:",
            points: [
              "Concept of intelligence and aptitude, Nature and theories of intelligence Spearman, Thurstone, Gullford Vernon, Sternberg and J.P; Das; Emotional Intelligence, Social intelligence, measurement of intelligence and aptitudes, concept of IQ, deviation IQ, constancy of IQ; Measurement of multiple intelligence; Fluid intelligence and crystallized intelligence."
            ]
          },
          {
            section: "11. Personality:",
            points: [
              "Definition and concept of personality; Theories of personality (psychoanalytical, sociocultural, interpersonal, developmental, humanistic, behaviouristic, trait and type approaches); Measurement of personality (projective tests, pencil-paper test); The Indian approach to personality; Training for personality development; Latest approaches like big 5 factor theory; The notion of self in different traditions."
            ]
          },
          {
            section: "12. Attitudes, Values and Interests:",
            points: [
              "Definition of attitudes, values and interests; Components of attitudes; Formation and maintenance of attitudes; Measurement of attitudes, values and interests; Theories of attitude change; Strategies for fostering values; Formation of stereotypes and prejudices; Changing others behaviour; Theories of attribution; Recent trends."
            ]
          },
          {
            section: "13. Language and Communication:",
            points: [
              "Human language - Properties, structure and linguistic hierarchy, Language acquisition- predisposition, critical period hypothesis; Theories of language development Skinner and Chomsky; Process and types of communication - effective communication training."
            ]
          },
          {
            section: "14. Issues and Perspectives in Modern Contemporary Psychology:",
            points: [
              "Computer application in the psychological laboratory and psychological testing; Artificial intelligence; Psychocybernetics; Study of consciousness-sleep-wake schedules; dreams, stimulus deprivation, meditation, hypnotic/drug induced states; Extrasensory perception; Intersensory perceptionSimulation studies."
            ]
          }
        ]
      },
      {
        title: "PAPER - II: Psychology: Issues and Applications",
        topics: [
          {
            section: "1. Psychological Measurement of Individual Differences:",
            points: [
              "The nature of individual differences; Characteristics and construction of standardized psychological tests; Types of psychological tests; Use, misuse and limitation of psychological tests; hical issues in the use of psychological tests."
            ]
          },
          {
            section: "2. Psychological well being and Mental Disorders:",
            points: [
              "Concept of health-ill health; Positive health, well being; Causal factors in mental disorders (Anxiety disorders, mood disorders, schizophrenia and delusional disorders; personality disorders, substance abuse disorders); Factors influencing positive health, well being, life style and quality of life; Happiness disposition."
            ]
          },
          {
            section: "3. Therapeutic Approaches:",
            points: [
              "Psychodynamic therapies; Behaviour therapies; Client centered therapy; Cognitive therapies; Indigenous therapies (Yoga, Meditation); Bio-feedback therapy; Prevention and rehabilitation of the mentally ill; Fostering mental health."
            ]
          },
          {
            section: "4. Work Psychology and Organisational Behaviour:",
            points: [
              "Personnel selection and training; Use of psychological tests in the industry; Training and human resource development; Theories of work motivation – Herzberg, Maslow, Adam Equity theory, Porter and Lawler, Vroom; Leadership and participatory management; Advertising and marketing; Stress and its management; Ergonomics; consumer psychology; Managerial effectiveness; Transformational leadership; Sensitivity training; Power and politics in organizations."
            ]
          },
          {
            section: "5. Application of Psychology to Educational Field:",
            points: [
              "Psychological principles underlying effective teaching-learning process; Learning styles; Gifted, retarded, learning disabled and their training; Training for improving memory and better academic achievement; Personality development and value education, Educational, vocational guidance and career counseling; Use of psychological tests in educational institutions; Effective strategies in guidance programmes."
            ]
          },
          {
            section: "6. Community Psychology:",
            points: [
              "Definition and concept of community psychology; Use of small groups in social action; Arousing community consciousness and action for handling social problems; Group decision making and leadership for social change; Effective strategies for social change."
            ]
          },
          {
            section: "7. Rehabilitation Psychology:",
            points: [
              "Primary, secondary and tertiary prevention programmes-role of psychologists; Organising of services for rehabilitation of physically, mentally and socially challenged persons including old persons, Rehabilitation of persons suffering from substance abuse, juvenile delinquency, criminal behaviour; Rehabilitation of victims of violence, Rehabilitation of HIV/AIDS victims, the role of social agencies."
            ]
          },
          {
            section: "8. Application of Psychology to disadvantaged groups:",
            points: [
              "The concepts of disadvantaged, deprivation; Social, physical, cultural and economic consequences of disadvantaged and deprived groups; Educating and motivating the disadvantaged towards development; Relative and prolonged deprivation."
            ]
          },
          {
            section: "9. Psychological problems of social integration:",
            points: [
              "The concept of social integration; The problem of caste, class, religion and language conflicts and prejudice; Nature and manifestation of prejudice between the in-group and out-group; Causal factors of social conflicts and prejudices; Psychological strategies for handling the conflicts and prejudices; Measures to achieve social integration."
            ]
          },
          {
            section: "10. Application of Psychology in Information Technology and Mass Media:",
            points: [
              "The present scenario of information technology and the mass media boom and the role of psychologists; Selection and training of psychology professionals to work in the field of IT and mass media; Distance learning through IT and mass media; Entrepreneurship through e- commerce; Multilevel marketing; Impact of TV and fostering value through IT and mass media; Psychological consequences of recent developments in Information Technology."
            ]
          },
          {
            section: "11. Psychology and Economic development:",
            points: [
              "Achievement motivation and economic development; Characteristics of entrepreneurial behaviour; Motivating and training people for entrepreneurship and economic development; Consumer rights and consumer awareness, Government policies for promotion of entrepreneurship among youth including women entrepreneurs."
            ]
          },
          {
            section: "12. Application of psychology to environment and related fields:",
            points: [
              "Environmental psychology-effects of noise, pollution and crowding; Population psychology: psychological consequences of population explosion and high population density; Motivating for small family norm; Impact of rapid scientific and technological growth on degradation of environment."
            ]
          },
          {
            section: "13. Application of psychology in other fields:",
            points: [
              "Military Psychology - Devising psychological tests for defence personnel for use in selection, Training, counseling; training psychologists to work with defence personnel in promoting positive health; Human engineering in defence.",
              "Sports Psychology - Psychological interventions in improving performance of athletes and sports. Persons participating in Individual and Team Games.",
              "Media influences on pro and antisocial behaviour.",
              "Psychology of terrorism."
            ]
          },
          {
            section: "14. Psychology of Gender:",
            points: [
              "Issues of discrimination, Management of diversity; Glass ceiling effect, Self fulfilling prophesy, Women and Indian society."
            ]
          }
        ]
      }
    ]
  },
  Physics: {
    papers: [
      {
        title: "Paper - I",
        topics: [
          {
            points: [
              "a) Mechanics of Particles:  Laws of motion; conservation of energy and momentum, applications to rotating frames, centripetal and Coriolis accelerations; Motion under a central force; Conservation of angular momentum, Kepler’s laws; Fields and potentials; Gravitational field and potential due to spherical bodies, Gauss and Poisson equations, gravitational self-energy; Two-body problem; Reduced mass; Rutherford scattering; Centre of mass and laboratory reference frames.",
              "b) Mechanics of Rigid Bodies:  System of particles; Centre of mass, angular momentum, equations of motion; Conservation theorems for energy, momentum and angular momentum; Elastic and inelastic collisions; Rigid Body; Degrees of freedom, Euler’s theorem, angular velocity, angular momentum, moments of inertia, theorems of parallel and perpendicular axes, equation of motion for rotation; Molecular rotations (as rigid bodies); Di and triatomic molecules; Precessional motion; top, gyroscope.",
              "c) Mechanics of Continuous Media:  Elasticity, Hooke’s law and elastic constants of isotropic solids and their inter-relation; Streamline (Laminar) flow, viscosity, Poiseuille’s equation, Bernoulli’s equation, Stokes’ law and applications.",
              "d) Special Relativity:  Michelson-Morely experiment and its implications; Lorentz transformations length contraction, time dilation, addition of relativistic velocities, aberration and Doppler effect, mass-energy relation, simple applications to a decay process. Four dimensional momentum vector; Covariance of equations of physics."
            ]
          },
          {
            section: "1. Waves and Optics:",
            points: [
              "Waves:  Simple harmonic motion, damped oscillation, forced oscillation and resonance; Beats; Stationary waves in a string; Pulses and wave packets; Phase and group velocities; Reflection and refraction from Huygens’ principle.",
              "Geometrial Optics:  Laws of reflection and refraction from Fermat’s principle; Matrix method in paraxial optic-thin lens formula, nodal planes, system of two thin lenses, chromatic and spherical aberrations.",
              "Interference:  Interference of light -Young’s experiment, Newton’s rings, interference by thin films, Michelson interferometer; Multiple beam interference and Fabry Perot interferometer.",
              "Diffraction:  Fraunhofer diffraction - single slit, double slit, diffraction grating, resolving power; Diffraction by a circular aperture and the Airy pattern; Fresnel diffraction: half-period zones and zone plates, circular aperture.",
              "Polarisation and Modern Optics:  Production and detection of linearly and circularly polarized light; Double refraction, quarter wave plate; Optical activity; Principles of fibre optics, attenuation; Pulse dispersion in step index and parabolic index fibres; Material dispersion, single mode fibers; Lasers-Einstein A and B coefficients. Ruby and He-Ne lasers. Characteristics of laser light-spatial and temporal coherence; Focusing of laser beams. Three-level scheme for laser operation; Holography and simple applications."
            ]
          },
          {
            section: "2. Electricity and Magnetism:",
            points: [
              "Electrostatics and Magnetostatics:  Laplace and Poisson equations in electrostatics and their applications; Energy of a system of charges, multipole expansion of scalar potential; Method of images and its applications. Potential and field due to a dipole, force and torque on a dipole in an external field; Dielectrics, polarisation. Solutions to boundaryvalue problems-conducting and dielectric spheres in a uniform electric field; Magnetic shell, uniformly magnetised sphere; Ferromagnetic materials, hysteresis, energy loss.",
              "Current Electricity:  Kirchhoff's laws and their applications. Biot-Savart law, Ampere’s law, Faraday’s law, Lenz’ law. Selfand mutual- inductances; Mean and rms values in AC circuits; DC and AC circuits with R, L and C components; Series and parallel resonance; Quality factor; Principle of transformer."
            ]
          },
          {
            points: [
              "Electromagnetic Waves and Blackbody Radiation:  Displacement current and Maxwell’s equations; Wave equations in vacuum, Poynting theorem; Vector and scalar potentials; Electromagnetic field tensor, covariance of Maxwell’s equations; Wave equations in isotropic dielectrics, reflection and refraction at the boundary of two dielectrics; Fresnel’s relations; Total internal reflection; Normal and anomalous dispersion; Rayleigh scattering; Blackbody radiation and Planck ’s radiation law- Stefan-Boltzmann law, Wien’s displacement law and Rayleigh-Jeans law."
            ]
          },
          {
            section: "3. Thermal and Statistical Physics:",
            points: [
              "Thermodynamics:  Laws of thermodynamics, reversible and irreversible processes, entropy; Isothermal, adiabatic, isobaric, isochoric processes and entropy changes; Otto and Diesel engines, Gibbs’ phase rule and chemical potential; Van der Waals equation of state of a real gas, critical constants; Maxwell-Boltzmann distribution of molecular velocities, transport phenomena, equipartition and virial theorems; Dulong-Petit, Einstein, and Debye’s theories of specific heat of solids; Maxwell relations and application; Clausius-Clapeyron equation. Adiabatic demagnetisation, Joule-Kelvin effect and liquefaction of gases.",
              "Statistical Physics:  Macro and micro states, statistical distributions, Maxwell-Boltzmann, Bose-Einstein and Fermi-Dirac Distributions, applications to specific heat of gases and blackbody radiation; Concept of negative temperatures."
            ]
          }
        ]
      },
      {
        title: "Paper - II",
        topics: [
          {
            section: "1.  Quantum Mechanics:",
            points: [
              "Wave-particle duality; Schroedinger equation and expectation values; Uncertainty principle; Solutions of the one-dimensional Schroedinger equation for free particle (Gaussian wave-packet), particle in a box, particle in a finite well, linear harmonic oscillator; Reflection and transmission by a step potential and by a rectangular barrier; Particle in a three dimensional box, density of states, free electron theory of metals; Angular momentum; Hydrogen atom; Spin half particles, properties of Pauli spin matrices."
            ]
          },
          {
            section: "2. Atomic and Molecular Physics:",
            points: [
              "Stern-Gerlach experiment, electron spin, fine structure of hydrozen atom; L-S coupling, J-J coupling; Spectroscopic notation of atomic states; Zeeman effect; Franck-Condon principle and applications; Elementary theory of rotational, vibrational and electronic spectra of diatomic molecules; Raman effect and molecular structure; Laser Raman spectroscopy; Importance of neutral hydrogen atom, molecular hydrogen and molecular hydrogen ion in astronomy. Fluorescence and Phosphorescence; Elementary theory and applications of NMR and EPR; Elementary ideas about Lamb shift and its significance."
            ]
          },
          {
            section: "3. Nuclear and Particle Physics:",
            points: [
              "Basic nuclear properties-size, binding energy, angular momentum, parity, magnetic moment; Semiempirical mass formula and applications. Mass parabolas; Ground state of a deuteron, magnetic moment and non-central forces; Meson theory of nuclear forces; Salient features of nuclear forces; Shell model of the nucleus - success and limitations; Violation of parity in beta decay; Gamma decay and internal conversion; Elementary ideas about Mossbauer spectroscopy; Q-value of nuclear reactions; Nuclear fission and fusion, energy production in stars. Nuclear reactors.",
              "Classification of elementary particles and their interactions; Conservation laws; Quark structure of hadrons: Field quanta of electroweak and strong interactions; Elementary ideas about unification of forces; Physics of neutrinos."
            ]
          },
          {
            section: "4. Solid State Physics, Devices and Electronics:",
            points: [
              "Crystalline and amorphous structure of matter; Different crystal systems, space groups; Methods of determination of crystal structure; X-ray diffraction, scanning and transmission electron microscopies; Band theory of solids—conductors, insulators and semi-conductors; Thermal properties of solids, specific heat, Debye theory; Magnetism: dia, para and ferromagnetism; Elements of super-conductivity, Meissner effect, Josephson junctions and applications; Elementary ideas about high temperature super-conductivity.",
              "Intrinsic and extrinsic semi-conductors- p-n-p and n-p-n transistors; Amplifiers and oscillators. Op-amps; FET, JFET and MOSFET; Digital electronics-Boolean identities, De Morgan’s laws, Logic gates and truth tables. Simple logic circuits; Thermistors, solar cells; Fundamentals of microprocessors and digital computers."
            ]
          }
        ]
      }
    ]
  },
  Zoology: {
    papers: [
      {
        title: "Paper - I",
        topics: [
          {
            section: "1. Non-chordata and Chordata:",
            points: [
              "1.1 Classification and relationship of various phyla up to subclasses: Acoelomate and Coelomate, Protostomes and Deuterostomes, Bilateria and Radiata; Status of Protista, Parazoa, Onychophora and Hemichordata; Symmetry.",
              "1.2 Protozoa: Locomotion, nutrition, reproduction, sex; General features and life history of Paramaecium, Monocystis. Plasmodium and Leishmania.",
              "1.3 Porifera: Skeleton, canal system and reproduction.",
              "1.4 Cnidaria: Polymorphism, defensive structures and their mechanism; coral reefs and their formation; metagenesis; general features and life history of Obelia and Aurelia.",
              "1.5 Platyhelminthes: Parasitic adaptation; general features and life history of Fasciola and Taenia and their-Pathogenic symptoms.",
              "1.6 Nemathelminthes: General features, life history, parasitic adaptation of Ascaris andWuchereria.",
              "1.7 Annelida: Coelom and metamerism; modes of life in polychaetes; general features and life history of Nereis, earthworm and leach.",
              "1.8 Arthropoda: Larval forms and parasitism in Crustacea; vision and respiration in arthropods (Prawn, cockroach and scorpion); modification of mouth, parts in insects (cockroach, mosquito, housefly, honey bee and butterfly), metamorphosis in insect and its hormonal regulation, social behaviour of Apis and termites.",
              "1.9 Molluscs: Feeding, respiration, locomotion, general features and life history of Lamellidens, Pila and Sepia. Torsion and detorsion in gastropods.",
              "1.10 Echinodermata: Feeding, respiration, locomotion, larval forms, general features and life history of Asterias.",
              "1.11 Protochordate: Origin of chordates; general features and life history of Branchiostoma and Herdmania.",
              "1.12 Pisces: Respiration, locomotion and migration.",
              "1.13 Amphibia: Origin of tetrapods, parental care, paedomorphosis.",
              "1.14 Reptilia; Origin of reptiles, skull types, status of Sphenodon and crocodiles.",
              "1.15 Aves: Origin of birds, flight adaptation, migration.",
              "1.16 Mammalia: Origin of mammals, dentition, general features of egg laying mammals, pouched mammals, aquatic mammals and primates, endocrine glands (pituitary, thyroid, parathyroid, adrenal, pancreas, gonads) and their interrelationships.",
              "1.17 Comparative functional anatomy of various systems of vertebrates. (integument and its derivatives, endoskeleton, locomotory organs, digestive system, respiratory system, circulatory system including heart and aortic arches, urinogenital system, brain and sense organs (eye and ear)."
            ]
          },
          {
            section: "2. Ecology:",
            points: [
              "2.1 Biosphere: concept of biosphere; biomes, Biogeochemical cycles, Human induced changes in atmosphere including greenhouse effect, ecological succession, biomes and ecotones, community ecology.",
              "2.2 Concept of ecosystem; structure and function of ecosystem, types of ecosystems, ecological succession, ecological adaptation.",
              "2.3 Population; characteristics, population dynamics, population stabilization.",
              "2.4 Biodiversity and diversity conservation of natural resources.",
              "2.5 Wildlife of India.",
              "2.6 Remote sensing for sustainable development.",
              "2.7 Environmental biodegradation; pollution and its impact on biosphere and its prevention."
            ]
          },
          {
            section: "3. Ethology:",
            points: [
              "3.1 Behaviour: Sensory filtering, responsiveness, sign stimuli, learning, and memory, instinct, habituation, conditioning, imprinting.",
              "3.2 Role of hormones in drive; role of pheromones in alarm spreading; crypsis, predator detection, predator tactics, social hierarchies in primates, social organization in insects.",
              "3.3 Orientation, navigation, homing; biological rhythms: biological clock, tidal, seasonal and circadian rhythms.",
              "3.4 Methods of studying animal behaviour including sexual conflict, selfishness, kinship and altruism."
            ]
          },
          {
            section: "4. Economic Zoology:",
            points: [
              "4.1 Apiculture, sericulture, lac culture, carp culture, pearl culture, prawn culture, vermiculture.",
              "4.2 Major infectious and communicable diseases (malaria, filaria, tuberculosis, cholera and AIDS) their vectors, pathogens and prevention.",
              "4.3 Cattle and livestock diseases, their pathogen (helminths) and vectors (ticks, mites, Tabanus, Stomoxys).",
              "4.4 Pests of sugar cane (Pyrilla perpusiella), oil seed (Achaeajanata) and rice (Sitophilus oryzae).",
              "4.5 Transgenic animals.",
              "4.6 Medical biotechnology, human genetic disease and genetic counselling, gene therapy.",
              "4.7 Forensic biotechnology."
            ]
          },
          {
            section: "5. Biostatistics:",
            points: [
              "5.1 Designing of experiments; null hypothesis; correlation, regression, distribution and measure of central tendency, chi square, student-test, F-test (one-way & two-way F-test)."
            ]
          },
          {
            section: "6. Instrumentation methods:",
            points: [
              "6.1 Spectrophotometer, phase contrast and fluorescence microscopy, radioactive tracer, ultra centrifuge, gel . electrophoresis, PCR, ELISA, FISH and chromosome painting.",
              "6.2 Electron microscopy (TEM, SEM)."
            ]
          }
        ]
      },
      {
        title: "Paper - II",
        topics: [
          {
            section: "1. Cell Biology:",
            points: [
              "1.1 Structure and function of cell and its organelles (nucleus, plasma membrane, mitochondria, Golgi bodies, endoplasmic reticulum, ribosomes and lysosomes), cell division (mitosis and meiosis), mitotic spindle and mitotic apparatus, chromosome movement chromosome type ploytene and lambrush, organization of chromatin, heterochromatin, Cell cycle regulation.",
              "1.2 Nucleic acid topology, DNA motif, DNA replication, transcription, RNA processing, translation, protein foldings and transport."
            ]
          },
          {
            section: "2. Genetics:",
            points: [
              "2.1 Modern concept of gene, split gene, genetic regulation, genetic, code.",
              "2.2 Sex chromosomes and their evolution, sex determination in Drosophila and human.",
              "2.3 Mendel’s laws of inheritance, recombination, linkage, multiple alleles, genetics of blood groups, pedigree analysis, hereditary diseases in human.",
              "2.4 Mutations and mutagenesis.",
              "2.5 Recombinant DNA technology, plasmid, cosmid, artificial chromosomes as vectors, transgenics, DNA cloning and whole animal cloning (principles and methods).",
              "2.6 Gene regulation and expression in prokaryotes and eukaryotes.",
              "2.7 Signal molecules, cell death, defects in signaling pathway and consequences.",
              "2.8 RFLP, RAPD and AFLF and application of RFLP in DNA finger-printing, ribozyme technologies, human genome project, genomics and protomics."
            ]
          },
          {
            section: "3. Evolution:",
            points: [
              "3.1 Theories of origin of life.",
              "3.2 Theories of evolution; Natural selection, role of mutation in evolution, evolutionary patterns, molecular drive, mimicry, variation, isolation and speciation.",
              "3.3 Evolution of horse, elephant and human using fossil data.",
              "3.4 Hardy-Weinberg Law.",
              "3.5 Continental drift and distribution of animals."
            ]
          },
          {
            section: "4. Systematics:",
            points: [
              "Zoological nomenclature, international code, cladistics, molecular taxonomy and biodiversity."
            ]
          },
          {
            section: "5. Biochemistry:",
            points: [
              "5.1 Structure and role of carbohydrates, fats, fatty acids, cholesterol, proteins and amino-acids, nucleic acids. Bioenergetics.",
              "5.2 Glycolysis and Krebs cycle, oxidation and reduction, oxidative phosphorylation; energy conservation and release, ATP, cycle cyclic AMP-its structure and role.",
              "5.3 Hormone classification (steroid and peptide hormones), biosynthesis and functions.",
              "5.4 Enzymes: types and mechanisms of action.",
              "5.5 Vitamins and co-enzymes.",
              "5.6 Immunoglobulin and immunity."
            ]
          },
          {
            section: "6. Physiology (with special reference to mammals):",
            points: [
              "6.1 Composition and constituents of blood; blood groups and Rh factor in human; factors and mechanism of coagulation; iron metabolism, acid-base balance, thermo regulation, anticoagulants.",
              "6.2 Haemoglobin: Composition, types and role in transport of oxygen and carbon dioxide.",
              "6.3 Digestion and absorption: Role of salivary glands, liver, pancreas and intestinal glands.",
              "6.4 Excretion: nephron and regulation of urine formation; osmo-regulation and excretory product.",
              "6.5 Muscles: Types, mechanism of contraction of skeletal muscles, effects of exercise on muscles.",
              "6.6 Neuron: nerve impulse—its conduction and synaptic transmission; neurotransmitters.",
              "6.7 Vision, hearing and olfaction in human.",
              "6.8 Physiology of reproduction, puberty and menopause in human."
            ]
          },
          {
            section: "7. Developmental Biology:",
            points: [
              "7.1 Gametogenesis; spermatogenesis, composition of semen, in vitro and in vivo capacitation of mammalian sperm, Oogenesis, totipotency; fertilization, morphogenesis and morphogen; blastogeneis, establishment of body axes formation, fate map, gestulation in frog and chick; genes in development in chick homeotic genes, development of eye and heart, placenta in mammals.",
              "7.2 Cell lineage, cell to cell interaction, Genetic and induced teratogenesis, role of thyroxine in control of metamorphosisin amphibia, paedogenesis and neoteny, cell death, aging.",
              "7.3 Developmental genes in human, in vitro fertilization; and embryo transfer; cloning.",
              "7.4 Stem cells: Sources, types and their use in human welfare.",
              "7.5 Biogenetic law."
            ]
          }
        ]
      }
    ]
  },
  Statistics: {
    papers: [
      {
        title: "Paper - I",
        topics: [
          {
            section: "1. Probability:",
            points: [
              "1.1 Sample space and events, probability measure and probability space, random variable as a measurable function.  distribution function of a random variable, discrete and continuous-type random variable, probability mass function, probability density function, vector-valued random variable, marginal and conditional distributions, stochastic independence of events and of random variables, expectation and moments of a random variable, conditional expectation, convergence of a sequence of random variable in distribution, in probability, in path mean and almost everywhere, their criteria and inter-relations, Chebyshev’s inequality and Khintchine’s weak law of large numbers, strong law of large numbers and Kolmogoroffs theorems, probability generating function, moment generating function, characteristic function, inversion theorem, Linderberg and Levy forms of central limit theorem, standard discrete and continuous probability distributions."
            ]
          },
          {
            section: "2. Statistical Inference:",
            points: [
              "2.1 Consistency, unbiasedness, efficiency, sufficiency, completeness, ancillary statistics, factorization theorem, exponential family of distribution and its properties, uniformly minimum variance unbiased (UMVU) estimation, Rao Blackwell and Lehmann-Scheffe theorems, Cramer-Rao inequality for single Parameter.",
              "2.2 Estimation by methods of moments, maximum likelihood, least squares, minimum chisquare and modified minimum chisquare, properties of maximum likelihood and other estimators, asymptotic efficiency, prior and posterior distributions, loss function, risk function, and minimax estimator. Bayes estimators.",
              "2.3 Non-randomised and randomised tests, critical function, MP tests, Neyman-Pearson lemma, UMP tests, monotone likelihood ratio: similar and unbiased tests, UMPU tests for single paramet likelihood ratio test and its asymptotic distribution. Confidence bounds and its relation with tests.",
              "2.4 Kolmogorov’s test for goodness of fit and its consistency, sign test and its optimality. Wilcoxon signedranks test and its consistency, Kolmogorov-Smirnov two sample test, run test, Wilcoxon-Mann-Whitney test and median test, their consistency and asymptotic normality. Wald’s SPRT and its properties, Oc and ASN functions for tests regarding parameters for Bernoulli, Poisson, normal and exponential distributions. Wald’s fundamental identity."
            ]
          },
          {
            section: "3. Linear Inference and Multivariate Analysis:",
            points: [
              "3.1 Linear statistical models, theory of least squares and analysis of variance, Gauss-Markoff theory, normal equations, least squares estimates and their precision, test of significance and interval estimates based on least squares theory in oneway, two-way and three-way classified data, regression analysis, linear regression, curvilinear regression and orthogonal polynomials, multiple regression, multiple and partial correlations, estimation of variance and covariance components, multivariate normal distribution, Mahalanobis’s D2 and Hotelling’s T2 statistics and their applications and properties, discriminant analysis, canonical correlations, principal component analysis."
            ]
          },
          {
            section: "4. Sampling Theory and Design of Experiments:",
            points: [
              "4.1 An outline of fixed-population and super-population approaches, distinctive features of finite population sampling, propability sampling designs, simple random sampling with and without replacement,  stratified random sampling, systematic sampling and its efficacy, cluster sampling, twostage and multi-stage sampling, ratio and regression methods of estimation involving one or more auxiliary variables, two-phase sampling, probability proportional to size sampling with and without replacement, the Hansen-Hurwitz and the HorvitzThompson estimators, non-negative variance estimation with reference to the Horvitz-Thompson estimator, non-sampling errors.",
              "4.2 Fixed effects model (two-way classification) random and mixed effects models (two-way classification with equal observation per cell), CRD, RBD, LSD and their analyses, incomplete block designs, concepts of orthogonality and balance, BIBD, missing plot technique, factorial experiments and 24 and 32, confounding in factorial experiments, split-plot and simple lattice designs, transformation of data Duncan’s multiple range test."
            ]
          }
        ]
      },
      {
        title: "Paper - II",
        topics: [
          {
            section: "1.Industrial Statistics:",
            points: [
              "1.1 Process and product control, general theory of control charts, different types of control charts for variables and attributes, X, R, s, p, np and  charts, cumulative sum chart. Single, double, multiple and sequential sampling plans for attributes, OC, ASN, AOQ and ATI curves, concepts of producer’s and consumer’s risks, AQL, LTPD and AOQL, Sampling plans for variables, Use of  Dodge-Romin tables.",
              "1.2 Concept of reliability, failure rate and reliability functions, reliability of series and parallel systems and other simple configurations, renewal density and renewal function, Failure models: exponential, Weibull, normal, lognormal. Problems in life testing, censored and truncated experiments for exponential models."
            ]
          },
          {
            section: "2. Optimization Techniques:",
            points: [
              "2.1 Different types of models in Operations Research, their construction and general methods of solution,  simulation and Monte-Carlo methods formulation of Linear Programming (LP) problem, simple LP model and its graphical solution, the simplex procedure, the two-phase metbod and the M-technique with artificial variables, the duality theory of LP and its economic interpretation, sensitivity analysis, transpotation and assignment problems, rectangular games, two-person zerosum games, methods of solution (graphical and algebraic).",
              "2.2 Replacement of failing or deteriorating items, group and individual replacement policies, concept of scientific inventory management and analytical structure of inventory problems, simple models with deterministic and stochastic demand with and without lead time, storage models with particular reference to dam type.",
              "2.3 Homogeneous discrete-time Markov chains, transition probability matrix, classification of states and ergodic theorems, homogeneous continuous-time Markov chains, Poisson process, elements of queuing theory, M/MI, M/M/K, G/M/l and M/G/1 queues.",
              "2.4 Solution of statistical problems on computers using wellknown statistical software packages like SPSS."
            ]
          },
          {
            section: "3. Quantitative Economics and Official Statistics:",
            points: [
              "3.1 Determination of trend, seasonal and cyclical components, Box-Jenkins method, tests for stationary series, ARIMA models and determination of orders of autoregressive and moving average components, fore-casting.",
              "3.2 Commonly used index numbers - Laspeyre’s, Paasche’s and Fisher’s ideal index numbers, chained-base index number, uses and limitations of index numbers, index number of wholesale prices, consumer price, agricultural production and industrial production, test for index numbers - proportionality, time-reversal, factor-reversal and circular.",
              "3.3 General linear model, ordinary least square and generalized least squares methods of estimation, problem of multi-collinearity, consequences and solutions of multi-collinearity, autocorrelation and its consequences, heteroscedasticity of disturbances and its testing, test for independence of disturbances concept of structure and model for simultaneous equations, problem of identification-rank and order conditions of identifiability, two-stage least squares method of estimation.",
              "3.4 Present official statistical system in India relating to population, agriculture, industrial production, trade and prices, methods of collection of official statistics, their reliability and limitations, principal publications containing such statistics, various official agencies responsible for data collection and their main functions."
            ]
          },
          {
            section: "4. Demography and Psychometry:",
            points: [
              "4.1 Demographic data from census, registration, NSS other surveys, their limitations. and uses, definition, construction and uses of vital rates and ratios, measures of fertility, reproduction rates, morbidity rate, standardized death rate, complete and abridged life tables, construction of life tables from vital statistics and census returns, uses of life tables, logistic and other population growth curves, fitting a logistic curve, population projection, stable population, quasi-stable population, techniques in estimation of demographic parameters, standard classification by cause of death, health surveys and use of hospital statistics.",
              "4.2 Methods of standardisation of scales and tests, Z-scores, standard scores, T-scores, percentile scores, intelligence quotient and its measurement and uses, validity and reliability of test scores and its determination, use of factor analysis and path analysis in psychometry."
            ]
          }
        ]
      }
    ]
  },
  Sociology: {
    papers: [
      {
        title: "Paper - I : FUNDAMENTALS OF SOCIOLOGY",
        topics: [
          {
            section: "1. Sociology - The Discipline:",
            points: [
              "1.1 Modernity and social changes in Europe and emergence of Sociology.",
              "1.2 Scope of the subject and comparison with other social sciences.",
              "1.3 Sociology and common sense."
            ]
          },
          {
            section: "2. Sociology as Science:",
            points: [
              "2.1 Science, scientific method and critique.",
              "2.2 Major theoretical strands of research methodology.",
              "2.3 Positivism and its critique.",
              "2.4 Fact value and objectivity.",
              "2.5 Non-positivist methodologies."
            ]
          },
          {
            section: "3. Research Methods and Analysis:",
            points: [
              "3.1 Qualitative and quantitative methods.",
              "3.2 Techniques of data collection.",
              "3.3 Variables, sampling, hypothesis, reliability and validity."
            ]
          },
          {
            section: "4. Sociological Thinkers:",
            points: [
              "4.1 Karl Marx - Historical materialism, mode of production, alienation, class struggle.",
              "4.2 Emile Durkheim - Division of labour, social fact, suicide, religion and society.",
              "4.3 Max Weber - Social action, ideal types, authority, bureaucracy, protestant ethic and the spirit of capitalism.",
              "4.4 Talcott Parsons - Social system, pattern variables.",
              "4.5 Robert K. Merton - Latent and manifest functions, conformity and deviance, reference groups.",
              "4.6 Mead - Self and identity."
            ]
          },
          {
            section: "5. Stratification and Mobility:",
            points: [
              "5.1 Concepts - equality, inequality, hierarchy, exclusion, poverty and deprivation.",
              "5.2 Theories of social stratification - Structural functionalist theory, Marxist theory, Weberian theory.",
              "5.3 Dimensions - Social stratification of class, status groups, gender, ethnicity and race.",
              "5.4 Social mobility - open and closed systems, types of mobility, sources and causes of mobility."
            ]
          },
          {
            section: "6. Works and Economic Life:",
            points: [
              "6.1 Social organization of work in different types of society - slave society, feudal society, industrial capitalist society.",
              "6.2 Formal and informal organization of work.",
              "6.3 Labour and society."
            ]
          },
          {
            section: "7. Politics and Society:",
            points: [
              "7.1 Sociological theories of power.",
              "7.2 Power elite, bureaucracy, pressure groups and political parties.",
              "7.3 Nation, state, citizenship, democracy, civil society, ideology.",
              "7.4 Protest, agitation, social movements, collective action, revolution."
            ]
          },
          {
            section: "8. Religion and Society:",
            points: [
              "8.1 Sociological theories of religion.",
              "8.2 Types of religious practices: animism, monism, pluralism, sects, cults.",
              "8.3 Religion in modern society: religion and science, secularization, religious revivalism, fundamentalism."
            ]
          },
          {
            section: "9. Systems of Kinship:",
            points: [
              "9.1 Family, household, marriage.",
              "9.2 Types and forms of family.",
              "9.3 Lineage and descent.",
              "9.4 Patriarchy and sexual division of labour.",
              "9.5 Contemporary trends."
            ]
          },
          {
            section: "10. Social Change in Modern Society:",
            points: [
              "10.1 Sociological theories of social change.",
              "10.2 Development and dependency.",
              "10.3 Agents of social change.",
              "10.4 Education and social change.",
              "10.5 Science, technology and social change."
            ]
          }
        ]
      },
      {
        title: "Paper - I: INDIAN SOCIETY: STRUCTURE AND CHANGE",
        topics: [
          {
            section: "1. Introducing Indian Society:",
            points: [
              {
                title: "1.1 Perspectives on the Study of Indian Society:",
                subpoints: [
                  "a) Indology (G.S. Ghure).",
                  "b) Structural functionalism (M. N. Srinivas).",
                  "c) Marxist sociology (A. R. Desai)."
                ]
              },
              {
                title: "1.2 Impact of colonial rule on Indian society:",
                subpoints: [
                  "a) Social background of Indian nationalism.",
                  "b) Modernization of Indian tradition.",
                  "c) Protests and movements during the colonial period.",
                  "d) Social reforms."
                ]
              }
            ]
          },
          {
            section: "2. Social Structure:",
            points: [
              {
                title: "2.1 Rural and Agrarian Social Structure:",
                subpoints: [
                  "a) The idea of Indian village and village studies.",
                  "b) Agrarian social structure—evolution of land tenure system, land reforms."
                ]
              },
              {
                title: "2.2 Caste System:",
                subpoints: [
                  "a) Perspectives on the study of caste systems: G. S. Ghurye, M. N. Srinivas, Louis Dumont, Andre Beteille.",
                  "b) Features of caste system.",
                  "c) Untouchability—forms and perspectives."
                ]
              },
              {
                title: "2.3 Tribal Communities in India:",
                subpoints: [
                  "a) Definitional problems.",
                  "b) Geographical spread.",
                  "c) Colonial policies and tribes.",
                  "d) Issues of integration and autonomy."
                ]
              },
              {
                title: "2.4 Social Classes in India:",
                subpoints: [
                  "a) Agrarian class structure.",
                  "b) Industrial class structure.",
                  "c) Middle classes in India."
                ]
              },
              {
                title: "2.5 Systems of Kinship in India:",
                subpoints: [
                  "a) Lineage and descent in India.",
                  "b) Types of kinship systems.",
                  "c) Family and marriage in India.",
                  "d) Household dimensions of the family.",
                  "e) Patriarchy, entitlements and sexual division of labour."
                ]
              },
              {
                title: "2.6 Religion and Society:",
                subpoints: [
                  "a) Religious communities in India.",
                  "b) Problems of religious minorities."
                ]
              }
            ]
          },
          {
            section: "3. Social Changes in India:",
            points: [
              {
                title: "3.1 Visions of Social Change in India:",
                subpoints: [
                  "a) Idea of development planning and mixed economy.",
                  "b) Constitution, law and social change.",
                  "c) Education and social change."
                ]
              },
              {
                title: "3.2 Rural and Agrarian Transformation in India:",
                subpoints: [
                  "a) Programmes of rural development, Community Development Programme, cooperatives, poverty alleviation schemes.",
                  "b) Green revolution and social change.",
                  "c) Changing modes of production in Indian agriculture.",
                  "d) Problems of rural labour, bondage, migration."
                ]
              },
              {
                title: "3.3 Industrialization and Urbanisation in India:",
                subpoints: [
                  "a) Evolution of modern industry in India.",
                  "b) Growth of urban settlements in India.",
                  "c) Working class: structure, growth, class mobilization.",
                  "d) Informal sector, child labour.",
                  "e) Slums and deprivation in urban areas."
                ]
              },
              {
                title: "3.4 Politics and Society:",
                subpoints: [
                  "a) Nation, democracy and citizenship.",
                  "b) Political parties, pressure groups, social and political elite.",
                  "c) Regionalism and decentralization of power.",
                  "d) Secularization."
                ]
              },
              {
                title: "3.5 Social Movements in Modern India:",
                subpoints: [
                  "a) Peasants and farmers movements.",
                  "b) Women’s movement.",
                  "c) Backward classes & Dalit movements.",
                  "d) Environmental movements.",
                  "Ethnicity and Identity movements."
                ]
              },
              {
                title: "3.6 Population Dynamics:",
                subpoints: [
                  "a) Population size, growth, composition and distribution.",
                  "b) Components of population growth: birth, death, migration.",
                  "c) Population Policy and family planning.",
                  "d) Emerging issues: ageing, sex ratios, child and infant mortality, reproductive health."
                ]
              },
              {
                title: "3.7 Challenges of Social Transformation:",
                subpoints: [
                  "a) Crisis of development: displacement, environmental problems and sustainability.",
                  "b) Poverty, deprivation and inequalities.",
                  "c) Violence against women.",
                  "d) Caste conflicts.",
                  "e) Ethnic conflicts, communalism, religious revivalism.",
                  "f) Illiteracy and disparities in education."
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "Civil Engineering": {
    papers: [
      {
        title: "PAPER-I",
        topics: [
          {
            section: "1. Engineering Mechanics, Strength of Materials and Structural Analysis.",
            points: []
          },
          {
            section: "2. Engineering Mechanics :",
            points: [
              "2.1 Units and Dimensions, SI Units, Vectors, Concept of Force, Concept of particle and rigid body. Concurrent, Non- Concurrent and parallel forces in a plane, moment of force free body diagram, conditions of equilibrium, Principle of virtual work, equivalent force system.",
              "2.2 First and Second Moment of area, Mass moment of Inertia.",
              "2.3 Static Friction.",
              "2.4 Kinematics and Kinetics: Kinematics in cartesian Co-ordinates, motion under uniform and non-uniform acceleration, motion under gravity. Kinetics of particle : Momentum and Energy principles, collision of elastic bodies, rotation of rigid bodies."
            ]
          },
          {
            section: "3. Strength of Materials :",
            points: [
              "3.1 Simple Stress and Strain, Elastic constants, axially loaded compression members, Shear force and bending moment, theory of simple bending, Shear Stress distribution across cross sections, Beams of uniform strength.",
              "3.2 Deflection of beams: Mecaulay’s method, Mohr’s Moment area method, Conjugate beam method, unit load method. Torsion of Shafts, Elastic stability of columns, Euler’s, Rankine’s and Secant formulae."
            ]
          },
          {
            section: "4. Structural Analysis :",
            points: [
              "4.1 Castiglianio’s theorems I and II, unit load method, of consistent deformation applied to beams and pin jointed trusses. Slope-deflection, moment distribution.",
              "4.2 Rolling loads and Influences lines : Influences lines for Shear Force and Bending moment at a section of a beam. Criteria for maximum shear force and bending Moment in beams traversed by a system of moving loads. Influences lines for simply supported plane pin jointed trusses.",
              "4.3 Arches : Three hinged, two hinged and fixed arches, rib shortening and temperature effects.",
              "4.4 Matrix methods of analysis : Force method and displacement method of analysis of indeterminate beams and rigid frames.",
              "4.5 Plastic Analysis of beams and frames : Theory of plastic bending, plastic analysis, statical method, Mechanism method.",
              "4.6 Unsymmetrical bending : Moment of inertia, product of inertia, position of Neutral Axis and Principal axes, calculation of bending stresses."
            ]
          },
          {
            section: "5. Design of Structures : Steel, concrete and masonry structures.",
            points: []
          },
          {
            section: "6. Structural Steel Design :",
            points: [
              "Structural steel : Factors of safety and load factors. Riveted, bolted and welded joints and connections. Design of tension and compression members, beams of built up section, riveted and welded plate girders, gantry girders, stancheons with battens and lacings."
            ]
          },
          {
            section: "7. Design of Concrete and Masonry Structures :",
            points: [
              "7.1 Concept of mix design. Reinforced Concrete : Working Stress and Limit State method of design— Recommendations of I. S. codes. design of one way and two way slabs, stair-case slabs, simple and continuous beams of rectangular, T and L sections. compression members under direct load with or without eccentricity.",
              "7.2 Cantilever and Counter fort type retaining walls.",
              "7.3 Water tanks : Design requirements for Rectangular and circular tanks resting on ground.",
              "7.4 Prestressed Concrete : Methods and systems of prestressing, anchorages, Analysis and design of sections for flexure based on working stress, loss of prestress.",
              "7.5 Design of brick masonry as per I. S. Codes"
            ]
          },
          {
            section: "8. Fluid Mechanics, open channel flow and Hydraulic Machines :",
            points: []
          },
          {
            section: "9. Fluid Mechanics :",
            points: [
              "9.1 Fluid properties and their role in fluid motion, fluid statics including forces acting on plane and curve surfaces.",
              "9.2 Kinematics and Dynamics of Fluid flow : Velocity and accelerations, stream lines, equation of continuity, irrotational and rotational flow, velocity potential and stream functions.",
              "9.3 Continuity, momentum, energy equation, Navier Stokes equation, Euler’s equation of motion, application to fluid flow problems, pipe flow, sluice gates, weirs."
            ]
          },
          {
            section: "10. Dimensional Analysis and Similitude:",
            points: [
              "Buckingham’s Pi-theorem, dimensionless parameters."
            ]
          },
          {
            section: "11. Laminar Flow :",
            points: [
              "Laminar flow between parallel, stationary and moving plates, flow through tube."
            ]
          },
          {
            section: "12. Boundary layer :",
            points: [
              "12.1 Laminar and turbulent boundary layer on a flat plate, laminar sub-layer, smooth and rough boundaries, drag and lift.",
              "12.2 Turbulent flow through pipes : Characteristics of turbulent flow, velocity distribution and variation of pipe friction factor, hydraulic grade line and total energy line."
            ]
          },
          {
            section: "13. Open channel flow :",
            points: [
              "Uniform and non-uniform flows, momentum and energy correction factors, specific energy and specific force, critical depth, rapidly varied flow, hydraulic jump, gradually varied flow, classification of surface profiles, control section, step method of integration of varied flow equation."
            ]
          },
          {
            section: "14. Hydraulic Machines and Hydropower :",
            points: [
              "14.1 Hydraulic turbines, types classification, Choice of turbines performance parameters, controls, characteristics, specific speed.",
              "14.2 Principles of hydropower development."
            ]
          },
          {
            section: "15. Geotechnical Engineering :",
            points: [
              "15.1 Soil Type and Structure—gradation and particle size distribution—consistency limits.",
              "15.2 Water in soil—capillary and structural—effective stress and pore water pressure— permeability concept—field and laboratory determination of permeability—Seepage pressure—quick sand conditions—Shear strength determination—Mohr Coulomb concept.",
              "15.3 Compaction of soil—Laboratory and field test.",
              "15.4 Compressibility and consolidation concept— consolidation theory—consolidation settlement analysis.",
              "15.5 Earth pressure theory and analysis for retaining walls, Application for sheet piles and Braced excavation.",
              "15.6 Bearing capacity of soil—approaches for analysis- Field tests—settlement analysis— stability of slope of earth walk.",
              "15.7 Subsuface exploration of soils—methods",
              "15.8 Foundation—Type and selection criteria for foundation of structures—Design criteria for foundation—Analysis of distribution of stress for footings and pile—pile group action—pile load test.",
              "15.9 Ground improvement techniques."
            ]
          }
        ]
      },
      {
        title: "PAPER—II",
        topics: [
          {
            section: "1. Construction Technology, Equipment, Planning and Management",
            points: []
          },
          {
            section: "2. Construction Technology",
            points: [
              "2.1 Engineering Materials :",
              "2.2 Physical properties of construction materials with respect to their use in construction—Stones, Bricks and Tiles; Lime, Cement, different types of Mortars and Concrete.",
              "2.3 Specific use of ferro cement, fibre reinforced C. C., High strength concrete.",
              "2.4 Timber; Properties defects—common preservation treatments.",
              "2.5 Use and selection of materials for specific use like Low Cost Housing, Mass Housing, High Rise Buildings."
            ]
          },
          {
            section: "3. Construction :",
            points: [
              "3.1 Masonry principles using Brick, stone, Blocks—construction detailing and strength characteristics.",
              "3.2 Types of plastering, pointing, flooring, roofing and construction features.",
              "3.3 Common repairs in buildings.",
              "3.4 Principle of functional planning of building for residents and specific use—Building code provisions.",
              "3.5 Basic principles of detailed and approximate estimating—specification writing and rate analysis-principles of valuation of real property.",
              "3.6 Machinery for earthwork, concreting and their specific uses—Factors affecting selection of equipments—operating cost of equipments."
            ]
          },
          {
            section: "4. CONSTRUCTION PLANNING AND MANAGEMENT :",
            points: [
              "4.1 Construction activity—schedules—organization for construction industry—Quality assurance principles.",
              "4.2 Use Basic principle of network—analysis in form of CPM and PERT—their use in construction monitoring, Cost optimization and resource allocation.",
              "4.3 Basic principles of Economic analysis and methods.",
              "4.4 Project profitability—Basic principles of Boot approach to financial planning-simple toll fixation criterions."
            ]
          },
          {
            section: "5. Surveying and Transportation Engineering",
            points: []
          },
          {
            section: "6. Surveying :",
            points: [
              "Common methods and instruments for distance and angle measurement for CE work—their use in plane table, traverse survey, levelling work, triangulation, contouring and topographical map. Basic principles of photogrammetry and remote sensing."
            ]
          },
          {
            section: "7. Railways Engineering :",
            points: [
              "Permanent way—components, types and their function- Functions and Design constituents of turn and crossing— Necessity of geometric design of track—Design of station and yards."
            ]
          },
          {
            section: " 8. Highway Engineering :",
            points: [
              "8.1 Principles of Highway alignments—classification and geometrical design elements and standards for Roads.",
              "8.2 Pavement structure for flexible and rigid pavements—Design principles and methodology of pavements.",
              "8.3 Typical construction methods and standards of materials for stabilized soil, WBM, Bituminous works and CC roads.",
              "8.4 Surface and sub-surface drainage arrangements for roads—culvert structures.",
              "8.5 Pavement distresses and strengthening by overlays.",
              "8.6 Traffic surveys and their application in traffic planning—Typical design features for channelized, intersection rotary etc.—signal designs—standard Traffic signs and markings."
            ]
          },
          {
            section: "9. Hydrology, Water Resources and Engineering :",
            points: []
          },
          {
            section: "10. Hydrology :",
            points: [
              "Hydrological cycle, precipitation, evaporation, transpiration, infiltration, overland flow, hydrograph, flood frequency analyses, flood routing through a reservoir, channel flow routing—Muskingam method."
            ]
          },
          {
            section: "11. Ground Water flow :",
            points: [
              "Specific yield, storage coefficient, coefficient of permeability, confined and unconfined aquifers, aquifers, aquitards, radial flow into a well under confined and unconfined conditions."
            ]
          },
          {
            section: "12. Water Resources Engineering :",
            points: [
              "Ground and surface water resources, single and multipurpose projects, storage capacity of reservoirs, reservoir losses, reservoir sedimentation."
            ]
          },
          {
            section: "13. Irrigation Engineering :",
            points: [
              "13.1 Water requirements of crops : consumptive use, duty and delta, irrigation methods and their efficiencies.",
              "13.2 Canals : Distribution systems for canal irrigation, canal capacity, canal losses, alignment of main and distributary canals, most efficient section, lined canals, their design, regime theory, critical shear stress, bed load.",
              "13.3 Water logging : causes and control, salinity.",
              "13.4 Canal structures : Design of head regulators, canal falls, aqueducts, metering flumes and canal outlets.",
              "13.5 Diversion head work : Principles and design of weirs on permeable and impermeable foundation, Khosla’s theory, energy dissipation.",
              "13.6 Storage works : Types of dams, design, principles of rigid gravity stability analysis.",
              "13.7 Spillways : Spillway types, energy dissipation.",
              "13.8 River training : Objectives of river training, methods of river training."
            ]
          },
          {
            section: "14. Environmental Engineering",
            points: []
          },
          {
            section: "15. Water Supply :",
            points: [
              "Predicting demand for water, impurities of water and their significance, physical, chemical and bacteriological analysis, waterborne diseases, standards for potable water."
            ]
          },
          {
            section: "16. Intake of Water :",
            points: [
              "Water treatment: principles of coagulation, flocculation and sedimentation; slow-, rapid-, pressure, filters; chlorination, softening, removal of taste, odour and salinity."
            ]
          },
          {
            section: "17. Sewerage Systems :",
            points: [
              "Domestic and industrial wastes, store sewage—separate and combined systems, flow through sewers, design of sewers."
            ]
          },
          {
            section: "18. Sewage Characterisation :",
            points: [
              "BOD, COD, solids, dissolved oxygen, nitrogen and TOC. Standards of disposal in normal water course and on land."
            ]
          },
          {
            section: "19. Sewage Treatment :",
            points: [
              "Working principles, units, chambers, sedimentation tank, trickling filters, oxidation ponds, activated sludge process, septic tank, disposal of sludge, recycling of waste water."
            ]
          },
          {
            section: "20. Solid waste :",
            points: [
              "Collection and disposal in rural and urban contexts, management of long-term ill-effects."
            ]
          },
          {
            section: "21. Environmental pollution :",
            points: [
              "Sustainable development. Radioactive wastes and disposal. Environmental impact assessment for thermal power plants, mines, river valley projects. Air pollution. Pollution control acts."
            ]
          }
        ]
      }
    ]
  },
  "Animal Husbandry and Veterinary Science": {
    papers: [
      {
        title: "PAPER-I",
        topics: [
          {
            section: "1. Animal Nutrition:",
            points: [
              "1.1 Partitioning of food energy within the animal. Direct and indirect calorimetry. Carbon— nitrogen balance and comparative slaughter methods. Systems for expressing energy value of foods in ruminants, pigs and poultry. Energy requirements for maintenance, growth, pregnancy, lactation, egg, wool, and meat production.",
              "1.2 Latest advances in protein nutrition. Energy protein inter-relationships. Evaluation of protein quality. Use of NPN compounds in ruminant diets. Protein requirements for maintenance, growth, pregnancy, lactation, egg, wool and meat production.",
              "1.3 Major and trace minerals—Their sources, physiological functions and deficiency symptoms. Toxic minerals. Mineral interactions. Role of fat soluble and water—soluble vitamins in the body, their sources and deficiency symptoms.",
              "1.4 Feed additives—methane inhibitors, probiotics, enzymes, antibiotics, hormones, oligosaccharides, antioxidants, emulsifiers, mould inhibitors, buffers etc. Use and abuse of growth promoters like hormones and antibiotics—latest concepts.",
              "1.5 Conservation of fodders. Storage of feeds and feed ingredients. Recent advances in feed technology and feed processing. Anti-nutritional and toxic factors present in livestock feeds. Feed analysis and quality control. Digestibility trials—direct, indirect and indicator methods. Predicting feed intake in grazing animals.",
              "1.6 Advances in ruminant nutrition. Nutrient requirements. Balanced rations. Feeding of calves, pregnant, work animals and breeding bulls. Strategies for feeding milch animals during different stages of lactation cycle. Effect of feeding on milk composition. Feeding of goats for meat and milk production. Feeding of sheep for meat and wool production.",
              "1.7 Swine Nutrition. Nutrient requirements. Creep, starter, grower and finisher rations. Feeding of pigs for lean meat production. Low cost rations for swine.",
              "1.8 Poultry nutrition. Special features of poultry nutrition. Nutrient requirements for meat and egg production. Formulation of rations for different classes of layers and broilers."
            ]
          },
          {
            section: "2. Animal Physiology:",
            points: [
              "2.1 Physiology of blood and its circulation, respiration; excretion. Endocrine glands in health and disease.",
              "2.2 Blood constituents.—Properties and functions-blood cell formation—Haemoglobin synthesis and chemistry-plasma proteins production, classification and properties, coagulation of blood; Haemorrhagic disorders—anti-coagulants—blood groups—Blood volume—Plasma expanders-Buffer systems in blood. Biochemical tests and their significance in disease diagnosis.",
              "2.3 Circulation.—Physiology of heart, cardiac cycle, heart sounds, heart beat, electrocardiograms. Work and efficiency of heart—effect of ions on heart function-metabolism of cardiac muscle, nervous and chemical regulation of heart, effect of temperature and stress on heart, blood pressure and hypertension, osmotic regulation, arterial pulse, vasomotor regulation of circulation, shock. Coronary and pulmonary circulation, Blood-Brain barrier Cerebrospinal fluid-circulation in birds.",
              "2.4 Respiration.—Mechanism of respiration, Transport and exchange of gases-neural control of respiration-Chemo-receptors-hypoxia-respiration in birds.",
              "2.5 Excretion.—Structure and function of kidney-formation of urine-methods of studying renal function-renal regulation of acid-base balance: physiological constituents of urine-renal failure-passive venous congestion-Urinary secretion in chicken-Sweat glands and their function. Bio-chemical test for urinary dysfunction.",
              "2.6 Endocrine glands.—Functional disorders—their symptoms and diagnosis. Synthesis of hormones, mechanism and control of secretion—hormonal receptors-classification and function.",
              "2.7 Growth and Animal Production.—Prenatal and postnatal growth, maturation, growth curves, measures of growth, factors affecting growth, conformation, body composition, meat quality.",
              "2.8 Physiology of Milk Production, Reproduction and Digestion.—Current status of hormonal control of mammary development, milk secretion and milk ejection. Male and Female reproductive organs, their components and functions. Digestive organs and their functions.",
              "2.9 Environmental Physiology.—Physiological relations and their regulation; mechanisms of adaptation, environmental factors and regulatory mechanisms involved in animal behaviour, climatology—various parameters and their importance. Animal ecology. Physiology of behaviour. Effect of stress on health and production."
            ]
          },
          {
            section: "3. Animal Reproduction:",
            points: [
              "Semen quality.—Preservation and Artificial Insemination—Components of semen, composition of spermatozoa, chemical and physical properties of ejaculated semen, factors affecting semen in vivo and in vitro. Factors affecting semen production and quality, preservation, composition of diluents, sperm concentration, transport of diluted semen. Deep freezing techniques in cows, sheep, goats, swine and poultry. Detection of oestrus and time of insemination for better conception. Anoestrus and repeat breeding."
            ]
          },
          {
            section: "4. Livestock Production and Management:",
            points: [
              "4.1 Commercial Dairy Farming.—Comparison of dairy farming in India with advanced countries. Dairying under mixed farming and as specialized farming, economic dairy farming. Starting of a dairy farm, Capital and land requirement, organization of the dairy farm. Opportunities in dairy farming, factors determining the efficiency of dairy animal. Heard recording, budgeting cost of milk production, pricing policy; Personnel Management. Developing Practical and Economic rations for dairy cattle; supply of greens throughout the year, feed and fodder requirements of Dairy Farm. Feeding regimes for young stock and bulls, heifers and breeding animals; new trends in feeding young and adult stock; Feeding records.",
              "4.2 Commercial meat, egg and wool production.—Development of practical and economic rations for sheep, goats, pigs, rabbits and poultry. Supply of greens, fodder, feeding regimes for young and mature stock. New trends in enhancing production and management. Capital and land requirements and socio-economic concept.",
              "4.3 Feeding and management of animals under drought, flood and other natural calamities."
            ]
          },
          {
            section: "5. Genetics and Animal Breeding:",
            points: [
              "5.1 History of animal genetics. Mitosis and Meiosis: Mendelian inheritance; deviations to Mendelian genetics; Expression of genes; Linkage and crossing over; Sex determination, sex influenced and sex limited characters; Blood groups and polymorphism; Chromosome aberrations; Cytoplasmic inheritance, Gene and its structure; DNA as a genetic material; Genetic code and protein synthesis; Recombinant DNA technology. Mutations, types of mutations, methods for detecting mutations and mutation rate, Transgenesis.",
              "5.2 Population Genetics applied to Animal Breeding—Quantitative Vs. Qualitative traits; Hardy Weinberg Law; Population Vs. Individual; Gene and genotypic frequency; Forces changing gene frequency; Random drift and small populations; Theory of path coefficient; Inbreeding, methods of estimating inbreeding coefficient, systems of inbreeding; Effective population size; Breeding value, estimation of breeding value, dominance and epistatic deviation; Partitioning of variation; Genotype X environment correlation and genotype X environment interaction; role of multiple measurements; Resemblance between relatives.",
              "5.3 Breeding Systems.—Breeds of livestock and Poultry. Heritability, repeatability and genetic and phenotypic correlations, their methods of estimation and precision of estimates; Aids to selection and their relative merits; Individual, pedigree, family and within family selection; Pregnancy testing; Methods of selection; Construction of selection indices and their uses; Comparative evaluation of genetic gains through various selection methods; Indirect selection and correlated response; Inbreeding, out breeding, upgrading, cross-breeding and synthesis of breeds; Crossing of inbred lines for commercial production; Selection for general and specific combining ability; Breeding for threshold characters. Sire index."
            ]
          },
          {
            section: "6. Extension:",
            points: [
              "Basic philosophy, objectives, concept and principles of extension. Different Methods adopted to educate farmers under rural conditions. Generation of technology, its transfer and feedback. Problems and constraints in transfer of technology. Animal husbandry programmes for rural development."
            ]
          }
        ]
      },
      {
        title: "PAPER-II",
        topics: [
          {
            section: "1. Anatomy, Pharmacology and Hygiene:",
            points: [
              "1.1 Histology and Histological Techniques : Paraffin embedding technique of tissue processing and H.E. staining—Freezing microtomy—Microscopy Bright field microscope and electron microscope. Cytology-structure of cell organells and inclusions; cell division-cell types—Tissues and their classification-embryonic and adult tissues—Comparative histology of organs—Vascular, Nervous, digestive, respiratory, musculo-skeletal and urogenital systems—Endocrine glands—Integuments—sense organs.",
              "1.2 Embryology.—Embryology of vertebrates with special reference to aves and domestic mammals gametogenesis-fertilization-germ layers-foetal membranes and placentation-types of placenta in domestic mammals-Teratology-twins and twinning-organogenesis-germ layer derivatives-endodermal, mesodermal and ectodermal derivatives.",
              "1.3 Bovine Anatomy.—Regional Anatomy : Paranasal sinuses of OX— surface anatomy of salivary glands. Regional anatomy of infraorbital, maxillary, mandi-buloalveolar, mental and cornnal nerve block. Regional anatomy of paravertebral nerves, pudental nerve, median, ulnar and radial nervestibial, fibular and digital nerves—Cranial nerves-structures involved in epidural anaesthesia-superficial lymph nodes-surface anatomy of visceral organs of thoracic, abdominal and pelvic cavities-comparative-features of locomotor apparatus and their application in the biomechanics of mammalian body.",
              "1.4 Anatomy of Fowl.—Musculo-skeletal system-functional anatomy in relation to respiration and flying, digestion and egg production.",
              "1.5 Pharmacology and Therapeutics Drugs.—Cellular level of pharmacodynamics and pharmacokinetics. Drugs acting on fluids and electrolyte balance. Drugs acting on Autonomic nervous system. Modern concepts of anaesthesia and dissociative anaesthetics. Autocoids. Antimicrobials and principles of chemotherapy in microbial infections. Use of hormones in therapeutics—chemotherapy of parasitic infections. Drug and economic concerns in the Edible tissues of animals—chemotherapy of Neoplastic diseases. Toxicity due to “insecticides, plants, metals, non-metals, zootoxins and mycotoxins”.",
              "1.6 Veterinary Hygiene with reference to water, air and habitation.—Assessment of pollution of water, air and soil—Importance of climate in animal health—effect of environment on animal function and performance relationship between industrialisation and animal agriculture—animal housing requirements for specific categories of domestic animals viz. pregnant cows and sows, milking cows, broiler birds—stress, strain and productivity in relation to animal habitation."
            ]
          },
          {
            section: "2. Animal Diseases :",
            points: [
              "2.1 Etiology, epidemiology pathogenesis, symptoms, post-mortem lesions, diagnosis, and control of infectious diseases of cattle, sheep and goat, horses, pigs and poultry.",
              "2.2 Etiology, epidemiology, symptoms, diagnosis, treatment of production diseases of cattle, horse, pig and poultry.",
              "2.3 Deficiency diseases of domestic animals and birds.",
              "2.4 Diagnosis and treatment of non-specific conditions like impaction, Bloat, Diarrhoea, Indigestion, dehydration, stroke, poisoning.",
              "2.5 Diagnosis and treatment of neurological disorders.",
              "2.6 Principles and methods of immunisation of animals against specific diseases—herd immunity—disease free zones—‘zero’ disease concept—chemoprophylaxis.",
              "2.7 Anaesthesia.—local, regional and general-preanesthetic medication. Symptoms and surgical interference in fractures and dislocation. Hernia, choking abomassal displacement— Caesarian operations. Rumenotomy—Castrations.",
              "2.8 Disease investigation techniques.—Materials for laboratory investigation— Establishment. Animal Health Centres—Disease free zone."
            ]
          },
          {
            section: "3. Veterinary Public Health :",
            points: [
              "3.1 Zoonoses.—Classification, definition, role of animals and birds in prevalence and transmission of zoonotic diseases—occupational zoonotic diseases.",
              "3.2 Epidemiology.—Principle, definition of epidemiological terms, application of epidemiological measures in the study of diseases and disease control. Epidemiological features of air, water and food borne infections. OIE regulation, WTO, sanitary and phytosanitary measures.",
              "3.3 Veterinary Jurisprudence.—Rules and Regulations for improvement of animal quality and prevention of animal diseases—State and Central Rules for prevention of animal and animal product borne diseases—S.P. C.A.—Veterolegal cases—Certificates—Materials and Methods of collection of samples for veterolegal investigation."
            ]
          },
          {
            section: "4. Milk and Milk Products Technology :",
            points: [
              "4.1 Market Milk.—Quality, testing and grading of raw milk. Processing, packaging, storing, distribution, marketing defects and their control. Preparation of the following milks : Pasteurized, standardized, toned, double toned, sterilized, homogenized, reconstituted, recombined and flavoured milks. Preparation of cultured milks, cultures and their management, yoghurt, Dahi, Lassi and Srikhand. Preparation of flavoured and sterilized milks. Legal standards. Sanitation requirement for clean and safe milk and for the milk plant equipment.",
              "4.2 Milk Products Technology.—Selection of raw materials, processing, storing, distributing and marketing milk products such as Cream, Butter, Ghee, Khoa, Channa, Cheese, condensed, evaporated, dried milk and baby food, ice cream and Kulfi; by-products, whey products, butter milk, lactose and casein. Testing, grading, judging milk products—BIS and Agmark specifications, legal standards, quality control nutritive properties. Packaging processing and operational control. Costing of dairy products."
            ]
          },
          {
            section: "5. Meat Hygiene and Technology :",
            points: []
          },
          {
            section: "6. Meat Hygiene",
            points: [
              "6.1 Ante mortem care and management of food animals, stunning, slaughter and dressing operations; abattoir requirements and designs; Meat inspection procedures and judgement of carcass meat cuts—grading of carcass meat cuts—duties and functions of Veterinarians in wholesome meat production.",
              "6.2 Hygienic methods of handling production of meat.—Spoilage of meat and control measures—Post- slaughter physicochemical changes in meat and factors that influence them— Quality improvement methods—Adulteration of meat and detection—Regulatory provisions in Meat trade and Industry."
            ]
          },
          {
            section: "7. Meat Technology",
            points: [
              "Physical and chemical characteristics of meat.—Meat emulsions—Methods of preservation of meat—Curing, canning, irradiation, packaging of meat and meat products, processing and formulations."
            ]
          },
          {
            section: "8.By-products.",
            points: [
              "Slaughter house by-products and their utilisation—Edible and inedible by products—Social and economic implications of proper utilisation of slaughter house by- products—Organ products for food and pharmaceuticals."
            ]
          },
          {
            section: "9. Poultry Products Technology.",
            points: [
              "9.1 Chemical composition and nutritive value of poultry meat, pre- slaughter care and management. Slaughtering techniques, inspection, preservation of poultry meat and products. Legal and BIS standards.",
              "9.2 Structure composition and nutritive value of eggs Microbial spoilage. Preservation and maintenance. Marketing of poultry meat, eggs and products."
            ]
          },
          {
            section: "10. Rabbit/Fur Animal farming.",
            points: [
              "Rabbit meat production. Disposal and utilization of fur and wool and recycling of waste by products. Grading of wool."
            ]
          }
        ]
      }
    ]
  },
  "Electrical Engineering": {
    papers: [
      {
        title: "1. PAPER-I",
        topics: [
          {
            section: "1.1 Circuits—Theory :",
            points: [
              "Circuit components; network graphs; KCL, KVL; Circuit analysis methods : nodal analysis, mesh analysis; basic network theorems and applications; transient analysis : RL, RC and RLC circuits; sinusoidal steady state analysis; resonant circuits; coupled circuits; balanced 3-phase circuits. Two-port networks."
            ]
          },
          {
            section: "1.2 Signals and Systems :",
            points: [
              "Representation of continuous-time and discrete-time signals and systems; LTI systems; convolution; impulse response; time-domain analysis of LTI systems based on convolution and differential/difference equations. Fourier transform, Laplace transform, Z-transform, Transfer function. Sampling and recovery of signals DFT, FFT Processing of analog signals through discrete-time systems."
            ]
          },
          {
            section: "1.3 Theory :",
            points: [
              "Maxwell’s equations, wave propagation in bounded media. Boundary conditions, reflection and refraction of plane waves. Transmission lines : travelling and standing waves, impedance matching, Smith chart."
            ]
          },
          {
            section: "1.4 Analog Electronics :",
            points: [
              "Characteristics and equivalent circuits (large and small-signal) of Diode, BJT, JFET and MOSFET. Diode circuits : Clipping, clamping, rectifier. Biasing and bias stability. FET amplifiers. Current mirror; Amplifiers : single and multi-stage, differential, operational feedback and power. Analysis of amplifiers; frequency-response of amplifiers. OPAMP circuits. Filters; sinusoidal oscillators : criterion for oscillation; single-transistor and OPAMP configurations. Function generators and wave-shaping circuits. Linear and switching power supplies."
            ]
          },
          {
            section: "1.5 Digital Electronics :",
            points: [
              "Boolean algebra; minimisation of Boolean functions; logic gates; digital IC families (DTL, TTL, ECL, MOS, CMOS). Combinational circuits : arithmetic circuits, code converters, multiplexers and decoders. Sequential circuits: latches and flip-flops, counters and shift-registers. Comparators, timers, multivibrators. Sample and hold circuits, ADCs and DACs. Semiconductor memories. Logic implementation using programmable devices (ROM, PLA, FPGA)."
            ]
          },
          {
            section: "1.6 Energy Conversion :",
            points: [
              "Principles of electromechanical energy conversion : Torque and emf in rotating machines. DC machines : characteristics and performance analysis; starting and speed control of motors. Transformers : principles of operation and analysis; regulation, efficiency; 3-phase transformers. 3-phase induction machines and synchronous machines : characteristics and performance analysis; speed control."
            ]
          },
          {
            section: "1.7 Power Electronics and Electric Drives :",
            points: [
              "Semi-conductor power devices : diode, transistor, thyristor, triac, GTO and MOSFET-static characteristics and principles of operation; triggering circuits; phase control rectifiers; bridge converters : fully-controlled and half-controlled; principles of thyristor choppers and inverters; DC-DC converters; Switch mode inverter; basic concepts of speed control of dc and ac motor drives applications of variable-speed drives."
            ]
          },
          {
            section: "1.8 Analog Communication :",
            points: [
              "Random variables : continuous, discrete; probability, probability functions. Statistical averages; probability models; Random signals and noise : white noise, noise equivalent bandwidth; signal transmission with noise; signal to noise ratio. Linear CW modulation : Amplitude modulation : DSB, DSB-SC and SSB. Modulators and Demodulators; Phase and Frequency modulation : PM & FM signals; narrows band FM; generation & detection of FM and PM, Deemphasis, Preemphasis. CW modulation system : Superhetrodyne receivers, AM receivers, communication receivers, FM receivers, phase locked loop, SSB receiver Signal to noise ratio calculation or AM and FM receivers."
            ]
          }
        ]
      },
      {
        title: "PAPER - II",
        topics: [
          {
            section: "1. Control Systems :",
            points: [
              "Elements of control systems; block-diagram representations; open-loop & closed-loop systems; principles and applications of feed-back. Control system components. LTI systems : time-domain and transform-domain analysis. Stability : Routh Hurwitz criterion, root-loci, Bode-plots and polor plots, Nyquist’s criterion; Design of lead-lad compensators. Proportional, PI, PID controllers. State-variable representation and analysis of control systems."
            ]
          },
          {
            section: "2. Microprocessors and Microcomputers :",
            points: [
              "PC organisation; CPU, instruction set, register set timing diagram, programming, interrupts, memory interfacing, I/O interfacing, programmable peripheral devices."
            ]
          },
          {
            section: "3. Measurement and Instrumentation :",
            points: [
              "Error analysis; measurement of current voltage, power, energy, power-factor, resistance, inductance, capacitance and frequency; bridge measurements. Signal conditioning circuit; Electronic measuring instruments : multimeter, CRO, digital voltmeter, frequency counter, Q-meter, spectrum-analyser, distortion-meter. Transducers : thermocouple, thermistor, LVDT, strain-guage, piezo-electric crystal."
            ]
          },
          {
            section: "4. Power Systems: Analysis and Control :",
            points: [
              "Steady-state performance of overhead transmission lines and cables; principles of active and reactive power transfer and distribution; per-unit quantities; bus admittance and impedance matrices; load flow; voltage control and power factor correction; economic operation; symmetrical components, analysis of symmetrical and unsymmetrical faults. Concepts of system stability : swing curves and equal area criterion.",
              "Static VAR system. Basic concepts of HVDC transmission."
            ]
          },
          {
            section: "5. Power System Protection :",
            points: [
              "Principles of overcurrent, differential and distance protection. Concept of solid state relays. Circuit breakers. Computer aided protection : introduction; line, bus, generator, transformer protection; numeric relays and application of DSP to protection."
            ]
          },
          {
            section: "6. Digital Communication :",
            points: [
              "Pulse code modulation (PCM), differential pulse code modulation (DPCM), delta modulation (DM), Digital modulation and demodulation schemes : amplitude, phase and frequency keying schemes (ASK, PSK, FSK). Error control coding : error detection and correction, linear block codes, convolution codes. Information measure and source coding. Data networks, 7-layer architecture."
            ]
          }
        ]
      }
    ]
  },
  Geology: {
    papers: [
      {
        title: "PAPER - I",
        topics: [
          {
            section: "1. General Geology :",
            points: [
              "The Solar System, meteorites, origin and interior of the earth and age of earth; Volcanoes— causes and products, Volcanic belts. Earthquakes—causes, effects, seismic of zone of India; Island arcs, trenches and mid-ocean ridges; Continental drift; Seafloor spreading, plate tectonics. Isostasy."
            ]
          },
          {
            section: "2. Geomorphology and Remote Sensing :",
            points: [
              "2.1 Basic concepts of geomorphology. Weathering and soil formations; Landforms, slopes and drainage. Geomorphic cycles and their interpretation. Morphology and its relation to structures and lithology; Coastal geomorphology; Applications of geomorphology in mineral prospecting, civil engineering; hydrology and environmental studies; Geomorphology of Indian sub-continent.",
              "2.2 Aerial photographs and their interpretation—merits and limitations; The Electromagnetic spectrum. Orbiting Satellites and Sensor Systems. Indian Remote Sensing Satellites. Satellite data products; Applications of remote sensing in geology; The Geographic Information System (GIS) and Global Positioning System (GPS)—its applications."
            ]
          },
          {
            section: "3. Structural Geology :",
            points: [
              "Principles of geologic mapping and map reading, projection diagrams, Stress and strain ellipsoid and stress-strain relationships of elastic, plastic and viscous materials; Strain markers in deformed rocks. Behaviour of minerals and rocks under deformation conditions. Folds and faults classification and mechanics; Structural analysis of folds, foliations, lineations, joints and faults, unconformities; Time-relationship between crystallization and deformation."
            ]
          },
          {
            section: "4. Paleontology :",
            points: [
              "4.1 Species—definition and nomenclature; Megafossils and Microfossils. Modes of preservation of fossils; Different kinds of microfossils; Application of microfossils in correlation, petroleum exploration, paleoclimatic and paleoceanographic studies; Evolutionary trend in Hominidae, Equidae and Proboscidae. Siwalik fauna.",
              "4.2 Gondwana flora and fauna and its importance; Index fossils and their significance."
            ]
          },
          {
            section: "5. Indian Stratigraphy :",
            points: [
              "Classification of stratigraphic sequences: lithostrati-graphic, biostratigraphic, chrono-stratigraphic and magnetostratigraphic and their interrelationships; Distribution and classification of Precambrian rocks of India; Study of stratigraphic distribution and lithology of Phanerozoic rocks of India with reference to fauna, flora and economic importance. Major boundary problems—Cambrian/ Precambrian, Permian/Triassic, Cretaceous/Tertiary and Pliocene/Pleistocene; Study of climatic conditions, paleogeography and igneous activity in the Indian sub-continent in the geological past. Tectonic framework of India. Evolution of the Himalayas."
            ]
          },
          {
            section: "6. Hydrogeology and Engineering Geology :",
            points: [
              "Hydrologic cycle and genetic classification of water; Movement of subsurface water; Springs; Porosity, permeability, hydraulic conductivity, transmissivity and storage coefficient, classification of aquifers; Water-bearing characteristics of rocks; Groundwater chemistry. Salt water intrusion. Types of wells. Drainage basin morphometry; Exploration for groundwater; Groundwater recharge; Problems and management of groundwater; Rainwater harvesting; Engineering properties of rocks; Geological investigations for dams, tunnels highways, railway and bridges; Rock as construction material; Landslides causes, prevention and rehabilitation; Earthquake-resistant structures."
            ]
          }
        ]
      },
      {
        title: "PAPER - II",
        topics: [
          {
            section: "1. Mineralogy :",
            points: [
              "1.1 Classification of crystals into systems and classes of symmetry; International system of crystallographic notation; Use of projection diagrams to represent crystal symmetry; Elements of X-ray crystallography.",
              "1.2 Physical and chemical characters of rock forming silicate mineral groups; Structural classification of silicates; Common minerals of igneous and metamorphic rocks; Minerals of the carbonate, phosphate, sulphide and halide groups; Clay minerals.",
              "1.3 Optical properties of common rock forming minerals; Pleochroism, extinction angle, double refraction, birefringence, twinning and dispersion in minerals."
            ]
          },
          {
            section: "2. Igneous and Metamorphic Petrology :",
            points: [
              "2.1 Generation and crystallisation of magmas. Crystallisation of albite—anorthite, diopside—anorthite and diopside—wollastonite—silica systems. Bowen's Reaction Principle; Magmatic differentiation and assimilation. Petrogenetic significance of the textures and structures of igneous rocks. Petrography and petrogenesis of granite, syenite, diorite, basic and ultrabasic groups, charnockite, anorthosite and alkaline rocks. Carbonatites. Deccan volcanic province.",
              "2.2 Types and agents of metamorphism. Metamorphic grades and zones; Phase rule. Facies of regional and contact metamorphism; ACF and AKF diagrams; Textures and structures of metamorphic rocks. Metamorphism of arenaceous, argillaceous and basic rocks; Minerals assemblages. Retrograde metamorphism; Metasomatism and granitisation, migmatites. Granulite terrains of India."
            ]
          },
          {
            section: "3. Sedimentary Petrology :",
            points: [
              "Sedimentas and Sedimentary rocks: Processes of formation; digenesis and lithification; Clastic and non-clastic rocks-their classification, petrography and depositional environment; Sedimentary facies and provenance. Sedimentary structures and their significance. Heavy minerals and their significance. Sedimentary basins of India."
            ]
          },
          {
            section: "4. Economic Geology :",
            points: [
              "Ore, ore mineral and gangue, tenor of ore. Classification of ore deposits; Processes of formation of mineral deposits; Controls of ore localisation; Ore textures and structures; Metallogenic epochs and provinces; Geology of the important Indian deposits of aluminium, chromium, copper, gold, iron, lead, zinc, manganese, titanium, uranium and thorium and industrial minerals; Deposits of coal and petroleum in India, National Mineral Policy; Conservation and utilization of mineral resources. Marine mineral resources and Law of Sea."
            ]
          },
          {
            section: "5. Mining Geology :",
            points: [
              "Methods of prospecting—geological, geophysical, geochemical and geobotanical; Techniques of sampling. Estimation of reserves of ore; Methods of exploration and mining-metallic ores, industrial minerals, marine mineral resources and building stones. Mineral beneficiation and ore dressing."
            ]
          },
          {
            section: "6. Geochemistry and Environmental Geology :",
            points: [
              "Cosmic abundance of elements. Composition of the planets and meteorites. Structure and composition of earth and distribution of elements. Trace elements. Elements of crystal chemistry-types of chemical bonds, coordination number. Isomorphism and polymorphism. Elementary thermodynamics. Natural hazards—floods, mass wasting, costal hazards, earthquakes and volcanic activity and mitigation; Environmental impact of urbanization, mining, industrial and radioactive waste disposal, use of fertilizers, dumping of mine waste and fly-ash. Pollution of ground and surface water, marine pollution. Environment protection— legislative measures in India; Sea level changes: causes and impact."
            ]
          }
        ]
      }
    ]
  },
  Law: {
    papers: [
      {
        title: "PAPER-I",
        topics: [
          {
            section: "1. Constitutional and administrative Law :",
            points: [
              "1.1 Constitution and Constitutionalism: The distinctive features of the Constitution.",
              "1.2 Fundamental Rights—Public interest litigation; Legal Aid; Legal services authority.",
              "1.3 Relationship between Fundamental rights, Directive principles and Fundamental duties.",
              "1.4 Constitutional Position of the President and relation with the Council of Ministers.",
              "1.5 Governor and his powers.",
              "1.6 Supreme Court and the High Courts: (a) Appointments and transfer. (b) Powers, functions and jurisdiction.",
              "1.7 Centre, States and local bodies: (a) Distribution of legislative powers between the Union and the States. (b) Local Bodies. (c) Administrative relationship among Union, State and Local Bodies. (d) Eminent domain-State property-common property-community property.",
              "1.8 Legislative powers, privileges and immunities.",
              "1.9 Services under the Union and the States: (a) Recruitment and conditions of services; Constitutional safeguards; Administrative tribunals. (b) Union Public Service Commission and State Public Service Commissions—Power and functions. (c) Election Commission—Power and functions.",
              "1.10 Emergency provisions.",
              "1.11 Amendment of the Constitution.",
              "1.12 Principle of Natural Justice—Emerging trends and judicial approach.",
              "1.13 Delegated legislation and its constitutionality.",
              "1.14 Separation of powers and constitutional governance.",
              "1.15 Judicial review of administrative action.",
              "1.16 Ombudsman: Lokayukta, Lokpal etc."
            ]
          },
          {
            section: "2. International Law :",
            points: [
              "2.1 Nature and Definition of International Law.",
              "2.2 Relationship between International Law and Municipal Law.",
              "2.3 State Recognition and State Succession.",
              "2.4 Law of the sea: Inland Waters,Territorial Sea, Contiguous Zone, Continental Shelf, Exclusive Economic Zone and High Seas.",
              "2.5 Individuals: Nationality, statelessness; Human Rights and procedures available for their enforcement.",
              "2.6 Territorial jurisdiction of States, Extradition and Asylum.",
              "2.7 Treaties : Formation, application, termination and reservation.",
              "2.8 United Nations : Its principal organs, powers and functions and reform.",
              "2.9 Peaceful settlement of disputes—different modes.",
              "2.10 Lawful recourse to force : aggressions, self-defence, intervention.",
              "2.11 Fundamental principles of international humanitarian law—International conventions and contemporary developments.",
              "2.12 Legality of the use of nuclear weapons; ban on testing of nuclear weapons; Nuclear non-proliferation treaty, CTST.",
              "2.13 International Terrorism, State sponsored terrorism, Hijacking, International Criminal Court.",
              "2.14 New International Economic Order and Monetary Law : WTO, TRIPS, GATT, IMF, World Bank.",
              "2.15 Protection and Improvement of the Human Environment : International Efforts."
            ]
          }
        ]
      },
      {
        title: "PAPER - II",
        topics: [
          {
            section: "1. Law of Crimes :—",
            points: [
              "1.1 General principles of Criminal liability : mens rea and actus reus, mens rea in statutory offences.",
              "1.2 Kinds of punishment and emerging trends as to abolition of capital punishment.",
              "1.3 Preparations and criminal attempt.",
              "1.4 General exceptions.",
              "1.5 Joint and constructive liability.",
              "1.6 Abetment.",
              "1.7 Criminal conspiracy.",
              "1.8 Offences against the State.",
              "1.9 Offences against public tranquility.",
              "1.10 Offences against human body.",
              "1.11 Offences against property.",
              "1.12 Offences against women.",
              "1.13 Defamation.",
              "1.14 Prevention of Corruption Act, 1988.",
              "1.15 Protection of Civil Rights Act, 1955 and subsequent legislative developments.",
              "1.16 Plea bargaining."
            ]
          },
          {
            section: "2. Law of Torts",
            points: [
              "2.1 Nature and definition.",
              "2.2 Liability based upon fault and strict liability; Absolute liability.",
              "2.3 Vicarious liability including State Liability.",
              "2.4 General defences.",
              "2.5 Joint tort fessors.",
              "2.6 Remedies.",
              "2.7 Negligence.",
              "2.8 Defamation.",
              "2.9 Nuisance.",
              "2.10 Conspiracy.",
              "2.11 False imprisonment.",
              "2.12 Malicious prosecution.",
              "2.13 Consumer Protection Act, 1986."
            ]
          },
          {
            section: "3. Law of Contracts and Mercantile Law",
            points: [
              "3.1 Nature and formation of contract/E-contract.",
              "3.2 Factors vitiating free consent.",
              "3.3 Void, voidable, illegal and unenforceable agreements.",
              "3.4 Performance and discharge of contracts.",
              "3.5 Quasi-contracts.",
              "3.6 Consequences of breach of contract.",
              "3.7 Contract of indemnity, guarantee and insurance.",
              "3.8 Contract of agency.",
              "3.9 Sale of goods and hire purchase.",
              "3.10 Formation and dissolution of partnership.",
              "3.11 Negotiable Instruments Act, 1881.",
              "3.12 Arbitration and Conciliation Act, 1996.",
              "3.13 Standard form contracts."
            ]
          },
          {
            section: "4. Contemporary Legal Developments",
            points: [
              "4.1 Public Interest Litigation.",
              "4.2 Intellectual property rights—Concept, types/prospects.",
              "4.3 Information Technology Law including Cyber Laws—Concept, purpose/prospects.",
              "4.4 Competition Law—Concept, purpose/prospects.",
              "4.5 Alternate Dispute Resolution—Concept, types/prospects.",
              "4.6 Major statutes concerning environmental law.",
              "4.7 Right to Information Act.",
              "4.8 Trial by media."
            ]
          }
        ]
      }
    ]
  }
};

export default optionalSubjectDetails;
